import {validateCustom, validateField, validateFinancialField} from "./validation";
import {Decimal} from 'decimal.js';
import moment from "moment";
import {checkIade, showBaro} from "../helper/permission"
import {AuthPageType, CustomerBankType, EntegratorIdentifiers} from "../helper/enums";
import {EntegratorConf} from "../constants";

export function isValidSGKAppointment(appointment) {
	let error = {};
	let errorMessage = "";

	if(!moment(appointment.appointmentTime).isValid()){
		errorMessage = errorMessage + " <strong>Randevu tarihi formatı hatalı</strong><br/>";
	}else {
		let hour = moment(appointment.appointmentTime).hour();
		if(hour<9 || hour>19){
			errorMessage = errorMessage + " <strong>Randevu saati sabah 9:00 akşam 19:59 arası olmalıdır.</strong><br/>";
		}
	}
	error.phone = validateField(undefined, "1,11", appointment.phone);
	if (!error.phone.valid) {
		errorMessage = errorMessage + " <strong>Telefon Numarası " + error.phone.message + "</strong><br/>";
	}
	error.email = validateField("email", "1,255", appointment.email);
	if (!error.email.valid) {
		errorMessage = errorMessage + " <strong>e-Posta " + error.email.message + "</strong><br/>";
	}
	error.note = validateField(undefined, "0,300", appointment.note);
	if (!error.note.valid) {
		errorMessage = errorMessage + " <strong>Açıklama " + error.note.message + "</strong><br/>";
	}

	let valid = isValidObject(error);
	return {error, valid, errorMessage};
}

export function isValidMedulaData(medulaData) {
	let error = {};
	let errorMessage = "";
	error.groupName = validateField(undefined, "1,255", medulaData ? medulaData.groupName : null);
	if (!error.groupName.valid) {
		errorMessage = errorMessage + " <strong>Ürün Adı/Reçete Grubu " + error.groupName.message + "</strong><br/>";
	}

	error.receiptCount = validateField("number", "1,45", medulaData ? medulaData.receiptCount : null);
	if (!error.receiptCount.valid) {
		errorMessage = errorMessage + " <strong>Reçete Adedi " + error.receiptCount.message + "</strong><br/>";
	}

	error.sgkMukellefKodu = validateField(undefined, "1,255", medulaData ? medulaData.sgkMukellefKodu : null);
	if (!error.sgkMukellefKodu.valid) {
		errorMessage = errorMessage + " <strong>Mükellef Kodu " + error.sgkMukellefKodu.message + "</strong><br/>";
	}

	error.sgkMukellefAdi = validateField(undefined, "1,255", medulaData ? medulaData.sgkMukellefAdi : null);
	if (!error.sgkMukellefAdi.valid) {
		errorMessage = errorMessage + " <strong>Mükellef Adı " + error.sgkMukellefAdi.message + "</strong><br/>";
	}

	error.sgkFileNo = validateField(undefined, "1,255", medulaData ? medulaData.sgkFileNo : null);
	if (!error.sgkFileNo.valid) {
		errorMessage = errorMessage + " <strong>Doküm Numarası Adı " + error.sgkFileNo.message + "</strong><br/>";
	}

	error.amount = validateField("number", "1,255", medulaData ? medulaData.amount : null);
	if (!error.amount.valid) {
		errorMessage = errorMessage + " <strong>Tutar " + error.amount.message + "</strong><br/>";
	}

	if (medulaData && medulaData.type === "medula") {
		error.allowanceAmount = validateField("number", "1,255", medulaData ? medulaData.allowanceAmount : null);
		if (!error.allowanceAmount.valid) {
			errorMessage = errorMessage + " <strong>İskonto Tutar " + error.allowanceAmount.message + "</strong><br/>";
		}

		error.kdv8Amount = validateField("number", "1,255", medulaData ? medulaData.kdv8Amount : null);
		if (!error.kdv8Amount.valid) {
			errorMessage = errorMessage + " <strong>%8 KDV " + error.kdv8Amount.message + "</strong><br/>";
		}

		error.kdv18Amount = validateField("number", "1,255", medulaData ? medulaData.kdv18Amount : null);
		if (!error.kdv18Amount.valid) {
			errorMessage = errorMessage + " <strong>%18 KDV " + error.kdv18Amount.message + "</strong><br/>";
		}

		error.remunerationAmount = validateField("number", "1,255", medulaData ? medulaData.remunerationAmount : null);
		if (!error.remunerationAmount.valid) {
			errorMessage = errorMessage + " <strong>Eczane Hizmet Bedeli " + error.remunerationAmount.message + "</strong><br/>";
		}

		error.remunerationKdvAmount = validateField("number", "1,255", medulaData ? medulaData.remunerationKdvAmount : null);
		if (!error.remunerationKdvAmount.valid) {
			errorMessage = errorMessage + " <strong>Eczane Hizmet Bed. Kdv Tutarı(%18) " + error.remunerationKdvAmount.message + "</strong><br/>";
		}

		error.totalPayableAmount = validateField("number", "1,255", medulaData ? medulaData.totalPayableAmount : null);
		if (!error.totalPayableAmount.valid) {
			errorMessage = errorMessage + " <strong>Toplam Ödenecek Tutar " + error.totalPayableAmount.message + "</strong><br/>";
		}
	} else {
		error.kdvPercentage = validateField("number", "1,255", medulaData ? medulaData.kdvPercentage : null);
		if (!error.kdvPercentage.valid) {
			errorMessage = errorMessage + " <strong>KDV Oranı " + error.kdvPercentage.message + "</strong><br/>";
		}
	}

	error.contributionAmount = validateField("number", "1,255", medulaData ? medulaData.contributionAmount : null);
	if (!error.contributionAmount.valid) {
		errorMessage = errorMessage + " <strong> Kat.Payı " + error.contributionAmount.message + "</strong><br/>";
	}

	error.payableAmount = validateField("number", "1,255", medulaData ? medulaData.payableAmount : null);
	if (!error.payableAmount.valid) {
		errorMessage = errorMessage + " <strong> Ödenecek Tutar " + error.payableAmount.message + "</strong><br/>";
	}

	let valid = isValidObject(error);
	return {error: error, valid: valid, errorMessage: errorMessage};
}

export function isValidMedulaOptikData(medulaData) {
	let error = {};
	let errorMessage = "";
	error.recipeCount = validateField("number", "1,255", medulaData ? medulaData.recipeCount : null);
	if (!error.recipeCount.valid) {
		errorMessage = errorMessage + " <strong>Reçete Sayısı " + error.recipeCount.message + "</strong><br/>";
	}

	error.exemptGiven = validateField("number", "1,255", medulaData ? medulaData.exemptGiven : null);
	if (!error.exemptGiven.valid) {
		errorMessage = errorMessage + " <strong>Muaf Verilen " + error.exemptGiven.message + "</strong><br/>";
	}

	error.percent10Given = validateField("number", "1,255", medulaData ? medulaData.percent10Given : null);
	if (!error.percent10Given.valid) {
		errorMessage = errorMessage + " <strong>%10 Katılımlı Verilen " + error.percent10Given.message + "</strong><br/>";
	}

	error.percent20Given = validateField("number", "1,255", medulaData ? medulaData.percent20Given : null);
	if (!error.percent20Given.valid) {
		errorMessage = errorMessage + " <strong>%20 Katılımlı Verilen " + error.percent20Given.message + "</strong><br/>";
	}

	error.totalGrossAmount = validateField("number", "1,255", medulaData ? medulaData.totalGrossAmount : null);
	if (!error.totalGrossAmount.valid) {
		errorMessage = errorMessage + " <strong>Toplam Brüt Reçete Tutar " + error.totalGrossAmount.message + "</strong><br/>";
	}

	error.totalShareAmount = validateField("number", "1,255", medulaData ? medulaData.totalShareAmount : null);
	if (!error.totalShareAmount.valid) {
		errorMessage = errorMessage + " <strong>Toplam Katılım Payı " + error.totalShareAmount.message + "</strong><br/>";
	}

	error.totalNetAmount = validateField("number", "1,255", medulaData ? medulaData.totalNetAmount : null);
	if (!error.totalNetAmount.valid) {
		errorMessage = errorMessage + " <strong>Toplam Net Reçete Tutarı " + error.totalNetAmount.message + "</strong><br/>";
	}

	let valid = isValidObject(error);
	return {error: error, valid: valid, errorMessage: errorMessage};
}

export function isValidMedikalIcmal(medikalIcmal) {
	let error = {};
	let errorMessage = "";
	error.contributionAmount = validateField("number", "1,255", medikalIcmal ? medikalIcmal.contributionAmount : null);
	if (!error.contributionAmount.valid) {
		errorMessage = errorMessage + " <strong>Toplam Katılım Payı " + error.contributionAmount.message + "</strong><br/>";
	}

	error.totalPayableAmount = validateField("number", "1,255", medikalIcmal ? medikalIcmal.totalPayableAmount : null);
	if (!error.totalPayableAmount.valid) {
		errorMessage = errorMessage + " <strong>Toplam Ödenecek Tutar " + error.totalPayableAmount.message + "</strong><br/>";
	}

	if (medikalIcmal && medikalIcmal.kdv0Amount && medikalIcmal.kdv0AmountExcluded) {
		error.kdv0Amount = validateField("number", "1,255", medikalIcmal ? medikalIcmal.kdv0Amount : null);
		if (!error.kdv0Amount.valid) {
			errorMessage = errorMessage + " <strong>KDV Dahil %0 Tutar " + error.kdv0Amount.message + "</strong><br/>";
		}

		error.kdv0AmountExcluded = validateField("number", "1,255", medikalIcmal ? medikalIcmal.kdv0AmountExcluded : null);
		if (!error.kdv0AmountExcluded.valid) {
			errorMessage = errorMessage + " <strong>KDV Hariç %0 Tutar " + error.kdv0AmountExcluded.message + "</strong><br/>";
		}
	}

	if (medikalIcmal && medikalIcmal.kdv8Amount && medikalIcmal.kdv8AmountExcluded) {
		error.kdv8Amount = validateField("number", "1,255", medikalIcmal ? medikalIcmal.kdv8Amount : null);
		if (!error.kdv8Amount.valid) {
			errorMessage = errorMessage + " <strong>KDV Dahil %8 Tutar " + error.kdv8Amount.message + "</strong><br/>";
		}

		error.kdv8AmountExcluded = validateField("number", "1,255", medikalIcmal ? medikalIcmal.kdv8AmountExcluded : null);
		if (!error.kdv8AmountExcluded.valid) {
			errorMessage = errorMessage + " <strong>KDV Hariç %8 Tutar " + error.kdv8AmountExcluded.message + "</strong><br/>";
		}
	}

	if (medikalIcmal && medikalIcmal.kdv18Amount && medikalIcmal.kdv18AmountExcluded) {
		error.kdv18Amount = validateField("number", "1,255", medikalIcmal ? medikalIcmal.kdv18Amount : null);
		if (!error.kdv18Amount.valid) {
			errorMessage = errorMessage + " <strong>KDV Dahil %18 Tutar " + error.kdv18Amount.message + "</strong><br/>";
		}

		error.kdv18AmountExcluded = validateField("number", "1,255", medikalIcmal ? medikalIcmal.kdv18AmountExcluded : null);
		if (!error.kdv18AmountExcluded.valid) {
			errorMessage = errorMessage + " <strong>KDV Hariç %18 Tutar " + error.kdv18AmountExcluded.message + "</strong><br/>";
		}
	}

	let valid = isValidObject(error);
	return {error: error, valid: valid, errorMessage: errorMessage};
}

export function isValidCezaeviData(cezaeviData) {
	let error = {};
	let errorMessage = "";
	error.recipeCount = validateField("number", "1,255", cezaeviData ? cezaeviData.recipeCount : null);
	if (!error.recipeCount.valid) {
		errorMessage = errorMessage + " <strong>Reçete Sayısı " + error.recipeCount.message + "</strong><br/>";
	}

	error.totalPrice = validateField("number", "1,255", cezaeviData ? cezaeviData.totalPrice : null);
	if (!error.totalPrice.valid) {
		errorMessage = errorMessage + " <strong>Reçete Psf Toplamı " + error.totalPrice.message + "</strong><br/>";
	}

	error.publicAllowance = validateField("number", "1,255", cezaeviData ? cezaeviData.publicAllowance : null);
	if (!error.publicAllowance.valid) {
		errorMessage = errorMessage + " <strong>Kamu Kurum İskontosu Toplamı " + error.publicAllowance.message + "</strong><br/>";
	}

	error.publicPriceTotal = validateField("number", "1,255", cezaeviData ? cezaeviData.publicPriceTotal : null);
	if (!error.publicPriceTotal.valid) {
		errorMessage = errorMessage + " <strong>Kamu Fiyatları Toplamı " + error.publicPriceTotal.message + "</strong><br/>";
	}

	error.medicineDifferenceAmount = validateField("number", "1,255", cezaeviData ? cezaeviData.medicineDifferenceAmount : null);
	if (!error.medicineDifferenceAmount.valid) {
		errorMessage = errorMessage + " <strong>İlaç Fark Toplamı " + error.medicineDifferenceAmount.message + "</strong><br/>";
	}

	error.allowance = validateField("number", "1,255", cezaeviData ? cezaeviData.allowance : null);
	if (!error.allowance.valid) {
		errorMessage = errorMessage + " <strong>İskonto Tutarı " + error.allowance.message + "</strong><br/>";
	}

	error.share10And20Amount = validateField("number", "1,255", cezaeviData ? cezaeviData.share10And20Amount : null);
	if (!error.share10And20Amount.valid) {
		errorMessage = errorMessage + " <strong>%10-20 Katılım Payları Toplamı " + error.share10And20Amount.message + "</strong><br/>";
	}

	error.kdv8Amount = validateField("number", "1,255", cezaeviData ? cezaeviData.kdv8Amount : null);
	if (!error.kdv8Amount.valid) {
		errorMessage = errorMessage + " <strong>KDV %8 " + error.kdv8Amount.message + "</strong><br/>";
	}

	error.payableAmount = validateField("number", "1,255", cezaeviData ? cezaeviData.payableAmount : null);
	if (!error.payableAmount.valid) {
		errorMessage = errorMessage + " <strong>Ödenecek Tutar " + error.payableAmount.message + "</strong><br/>";
	}

	error.remuneration = validateField("number", "1,255", cezaeviData ? cezaeviData.remuneration : null);
	if (!error.remuneration.valid) {
		errorMessage = errorMessage + " <strong>Eczane Hizmet Bedeli " + error.remuneration.message + "</strong><br/>";
	}

	error.remunerationKdv18 = validateField("number", "1,255", cezaeviData ? cezaeviData.remunerationKdv18 : null);
	if (!error.remunerationKdv18.valid) {
		errorMessage = errorMessage + " <strong>Eczane Hizmet Bedeli (%18) " + error.remunerationKdv18.message + "</strong><br/>";
	}

	error.totalPayablePrice = validateField("number", "1,255", cezaeviData ? cezaeviData.totalPayablePrice : null);
	if (!error.totalPayablePrice.valid) {
		errorMessage = errorMessage + " <strong>Toplam Ödenecek Tutar " + error.totalPayablePrice.message + "</strong><br/>";
	}

	let valid = isValidObject(error);
	return {error: error, valid: valid, errorMessage: errorMessage};
}

export function isValidSendMail(mail) {
	let error = {};
	let errorMessage = "";
	if (!mail.mailProperty) {
		error.mailProperty = {valid: false, message: 'Gönderici E-Posta Adresi seçmelisiniz.'};
		errorMessage = errorMessage + " <strong>Gönderici E-Posta Adresi seçmelisiniz.</strong><br/>";
	}

	if (!(mail.isSendPDF || mail.isSendXML)) {
		error.isSendPDF = {valid: false, message: 'En az bir adet doküman tipi seçmelisiniz(XML, PDF)'};
		errorMessage = errorMessage + " <strong>En az bir adet doküman tipi seçmelisiniz(XML, PDF)</strong><br/>";
	}
	error.toMail = validateField("email", "1,255", mail.toMail);
	if (!error.toMail.valid) {
		errorMessage = errorMessage + " <strong>Alıcı E-Posta Adresi formatı uygun değil</strong><br/>";
	}

	error.receiver = validateField(undefined, "1,255", mail.receiver);
	if (!error.receiver.valid && mail.type !== "progressPaymentHakedis") {
		errorMessage = errorMessage + " <strong>Alıcı Adı ve Soyadı " + error.receiver.message + "</strong><br/>";
	}
	error.subject = validateField(undefined, "1,500", mail.subject);
	if (!error.subject.valid) {
		errorMessage = errorMessage + " <strong>Konu başlığı " + error.receiver.message + "</strong><br/>";
	}
	let valid = isValidObject(error);
	return {error: error, valid: valid, errorMessage: errorMessage};
}

export function isValidVoucherModalData(data) {
	let error = {};
	let errorMessage = "";
	error.itemName = validateField(undefined, "1,1000", data.itemName);
	if (!error.itemName.valid) {
		errorMessage = errorMessage + " <strong>Ücretin Ne için Alındığı alanı boş bırakılamaz</strong><br/>";
	}
	error.amount = validateField("decimal", "1,45", data.amount);
	if (!error.amount.valid) {
		errorMessage = errorMessage + " <strong>Tutar alanı boş bırakılamaz</strong><br/>";
	}
	error.damgaVergisiPercentage = validateField("decimal", "1,45", data.damgaVergisiPercentage);
	if (!error.damgaVergisiPercentage.valid) {
		errorMessage = errorMessage + " <strong>Damga Vergisi Oranı alanı boş bırakılamaz</strong><br/>";
	}
	let valid = isValidObject(error);
	return {error: error, valid: valid, errorMessage: errorMessage};
}

export function isValidKonaklamaVergisiModalData(data) {
	let error = {};
	let errorMessage = "";
	error.itemName = validateField(undefined, "1,1000", data.itemName);
	if (!error.itemName.valid) {
		errorMessage = errorMessage + " <strong>Ürün/Hizmet adı alanı boş bırakılamaz</strong><br/>";
	}
	error.amount = validateField("decimal", "1,45", data.amount);
	if (!error.amount.valid || data.amount === "0") {
		if(data.amount === "0"){
			errorMessage = errorMessage + " <strong>Tutar alanı 0 olamaz</strong><br/>";
			error.amount.valid = false;
		}else {
		errorMessage = errorMessage + " <strong>Tutar alanı boş bırakılamaz</strong><br/>";
		error.amount.valid = false;
	}
	}
	error.quantity = validateField("decimal","1,10",data.quantity);
	if (!error.quantity.valid || data.quantity === "0") {
		if(data.quantity === "0"){
			errorMessage = errorMessage + " <strong>Miktar alanı 0 olamaz</strong><br/>";
			error.quantity.valid = false;
		}else {
			errorMessage = errorMessage + " <strong>Miktar alanı boş bırakılamaz</strong><br/>";
			error.quantity.valid = false;
		}
	}
	let valid = isValidObject(error);
	return {error: error, valid: valid, errorMessage: errorMessage};
}

export function isValidSearchField(requiredFields, reportType) {
	let error = {};
	let errorMessage = "";
	let issueDateStart, issueDateEnd;
	for(let i=0;i<requiredFields.length;i++){
		let requiredField = requiredFields[i];
		error[requiredField.name] = validateField((requiredField.rule==='date' ? 'date':undefined), requiredField.rule, ((requiredField.type==='between' && requiredField.name.indexOf('_end') !== -1) ? requiredField.end: requiredField.start));
		if (!error[requiredField.name].valid) {
			errorMessage = errorMessage + " <strong>" + requiredField.label + error[requiredField.name].message+"</strong><br/>";
		}

		if (requiredField.name === "document_issue_date") {
			issueDateStart = requiredField.start;
			issueDateEnd = requiredField.end;
		}
	}

	if (reportType === "ECZACIPOS_SALES_REPORT") {
		if (!issueDateStart) {
			errorMessage = errorMessage + " <strong> Fatura Tarihi(Başlangıç) boş olamaz.</strong><br/>";
			error.startDate = {valid: false};
		}

		if (!issueDateEnd) {
			errorMessage = errorMessage + " <strong> Fatura Tarihi(Bitiş) boş olamaz.</strong><br/>";
			error.startDate = {valid: false};
		}

		if (issueDateStart && issueDateEnd) {
			if (new moment(issueDateEnd).diff(new moment(issueDateStart), "days") > 90) {
				errorMessage = errorMessage + " <strong> Fatura Tarihi(Başlangıç) ve Fatura Tarihi(Bitiş) arasındaki fark maksimum 3 ay olmalıdır.</strong><br/>";
				error.startDate = {valid: false};
			}
		}
	}

	let valid = isValidObject(error);
	return {error: error, valid: valid, errorMessage: errorMessage};
}

export function isValidRequiredFieldData(requiredField) {
	let error = {};
	let errorMessage = "";
	error.naceCode = validateField(undefined, "1,255", requiredField.naceCode);
	if (!error.naceCode.valid) {
		errorMessage = errorMessage + " <strong>NACE Kodu "+ error.naceCode.message+"</strong><br/>";
	}
	error.city = validateField(undefined, "1,45", requiredField.city);
	if (!error.city.valid) {
		errorMessage = errorMessage + " <strong>Vergi Dairesinin Bulunduğu İl "+ error.city.message+"</strong><br/>";
	}
	error.taxOffice = validateField(undefined, "1,255", requiredField.taxOffice);
	if (!error.taxOffice.valid) {
		errorMessage = errorMessage + " <strong>Vergi Dairesi "+ error.taxOffice.message+"</strong><br/>";
	}
	error.mersisNo = validateField("number", "0,16", requiredField.mersisNo);
	if (!error.mersisNo.valid) {
		errorMessage = errorMessage + " <strong>Mersis no "+ error.mersisNo.message+"</strong><br/>";
	}
	error.ticaretSicilNo = validateField(undefined, "0,45", requiredField.ticaretSicilNo);
	if (!error.ticaretSicilNo.valid) {
		errorMessage = errorMessage + " <strong>Ticaret Sicil No "+ error.ticaretSicilNo.message+"</strong><br/>";
	}
	error.streetName = validateField(undefined, "1,255", requiredField.streetName);
	if (!error.streetName.valid) {
		errorMessage = errorMessage + " <strong>Cadde "+ error.streetName.message+"</strong><br/>";
	}
	error.buildingName = validateField(undefined, "0,255", requiredField.buildingName);
	if (!error.buildingName.valid) {
		errorMessage = errorMessage + " <strong>Bina Adı "+ error.buildingName.message+"</strong><br/>";
	}
	error.buildingNo = validateField(undefined, "0,16", requiredField.buildingNo);
	if (!error.buildingNo.valid) {
		errorMessage = errorMessage + " <strong>Bina Numarası "+ error.buildingNo.message+"</strong><br/>";
	}
	error.doorNo = validateField(undefined, "0,16", requiredField.doorNo);
	if (!error.doorNo.valid) {
		errorMessage = errorMessage + " <strong>Kapı Numarası "+ error.doorNo.message+"</strong><br/>";
	}
	error.postalCode = validateField("number", "4,6", requiredField.postalCode);
	if (!error.postalCode.valid) {
		errorMessage = errorMessage + " <strong>Posta Kodu "+ error.postalCode.message+"</strong><br/>";
	}
	error.phone = validateField(undefined, "1,32", requiredField.phone);
	if (!error.phone.valid) {
		errorMessage = errorMessage + " <strong>Telefon "+ error.phone.message+"</strong><br/>";
	}
	error.fax = validateField(undefined, "0,32", requiredField.fax);
	if (!error.fax.valid) {
		errorMessage = errorMessage + " <strong>Fax "+ error.fax.message+"</strong><br/>";
	}
	error.email = validateField("email", "0,45", requiredField.email);
	if (!error.email.valid) {
		errorMessage = errorMessage + " <strong>e-Posta "+ error.email.message+"</strong><br/>";
	}
	error.commerceChamber = validateField(undefined, "0,255", requiredField.commerceChamber);
	if (!error.commerceChamber.valid) {
		errorMessage = errorMessage + " <strong>Kayıtlı Olunan Baro " + error.commerceChamber.message + "</strong><br/>";
	}
	let valid = isValidObject(error);
	return {error: error, valid: valid, errorMessage: errorMessage};
}

export function isValidRequestMessage(data) {
	let error = {};
	let errorMessage = "";
	error.subjectType = validateField(undefined, "1,45", data ? data.subjectType : null);
	if (!error.subjectType.valid) {
		errorMessage = errorMessage + " <strong>Konu Tipi " + error.subjectType.message + "</strong><br/>";
	}
	error.subject = validateField(undefined, "1,255", data ? data.subject : null);
	if (!error.subject.valid) {
		errorMessage = errorMessage + " <strong>Konu " + error.subject.message + "</strong><br/>";
	}
	error.message = validateField(undefined, "1,5000", data ? data.message : null);
	if (!error.message.valid) {
		errorMessage = errorMessage + " <strong>Açıklama " + error.message.message + "</strong><br/>";
	}
	error.phone = validateField(undefined, "1,11", data ? data.phone : null);
	if (!error.phone.valid) {
		errorMessage = errorMessage + " <strong>Telefon Numarası " + error.message.message + "</strong><br/>";
	}
	error.email = validateField(undefined, "1,500", data ? data.email : null);
	if (!error.email.valid) {
		errorMessage = errorMessage + " <strong>eMail " + error.message.message + "</strong><br/>";
	}
	let valid = isValidObject(error);
	return {error: error, valid: valid, errorMessage: errorMessage};
}

//todo: paytr validasyon eklenenecek
export function isValidPayTrOrder(data) {
	let error = {};
	let errorMessage = "";
	return {error: error, valid: true, errorMessage: errorMessage};
}

export function isValidERPOutboxPyld(outbox,index) {
	let error = {};
	let errorMessage = "";
	error['vknTckn'] = validateField(undefined, "10,11", outbox.vknTckn);
	if (!error['vknTckn'].valid) {
		errorMessage = errorMessage + "vkn/tckn " + error['vknTckn'].message + "\n";
	}
	if(outbox.documentId){
		error['documentId'] = validateField("faturano", "0,16", outbox.documentId);
		if (!error['documentId'].valid) {
			errorMessage = errorMessage + error['documentId'].message+ "\n";
		}
	}
	if(outbox.despatchTypeCode){
		error['postalZone'] = validateField(undefined, "4,16", outbox.postalZone);
		if (!error['postalZone'].valid) {
			errorMessage = errorMessage  + "Alıcı Posta Kodu " + error['postalZone'].message + "\n";
		}

		if (outbox.deliveryType === 'CARRIER') {
			error['carrierId'] = validateField(undefined, "10,11", outbox.carrierId);
			if (!error['carrierId'].valid) {
				errorMessage = errorMessage + "Taşıyıcı VKN/TCKN " + error['carrierId'].message + "\n";
			}
			error['carrierTitle'] = validateField(undefined, "2,500", outbox.carrierTitle);
			if (!error['carrierTitle'].valid) {
				errorMessage = errorMessage + "Taşıyıcı Ünvan " + error['carrierTitle'].message +"\n";
			}
		}

		if (outbox.deliveryType === 'DRIVER') {
			error['driverFirstName'] = validateField(undefined, "1,45", outbox.driverFirstName);
			if (!error['driverFirstName'].valid) {
				errorMessage = errorMessage + "Şoför Adı " + error['driverFirstName'].message + "\n";
			}

			error['driverFamilyName'] = validateField(undefined, "1,45", outbox.driverFamilyName);
			if (!error['driverFamilyName'].valid) {
				errorMessage = errorMessage + "Şoför Soyadı " + error['driverFamilyName'].message +"\n";
			}

			error['transportId'] = validateField(undefined, "1,45", outbox.transportId);
			if (!error['transportId'].valid) {
				errorMessage = errorMessage + "Plaka numarası " + error['transportId'].message;
			}
		}
	}
	let valid = isValidObject(error);
	return {error, valid, errorMessage};
}

export function isValidJournal(journal){
  let error = {};
  let errorMessage = "";
  error.ENTERED_DATE = validateField(undefined, "1,45", journal.ENTERED_DATE);
  if (!error.ENTERED_DATE.valid) {
    errorMessage = errorMessage + " <strong>Giriş Tarihi " + error.ENTERED_DATE.message + "</strong><br/>";
  }
}

export function isValidInboxLine(inboxLineList) {
	let error = {};
	let errorMessage = "";

	for(let i=0;i<inboxLineList.length;i++){
		error['itemName_'  + i] = validateField(undefined, "1,1000", inboxLineList[i].itemName);
		if (!error['itemName_'  + i].valid) {
			errorMessage = errorMessage + " <strong>" + (i + 1) + ". satırdaki ERP Ürün/Hizmet " + error['itemName_' +  i].message + "</strong><br/>";
		}

		error['itemCode_' +  i] = validateField(undefined, "1,45", inboxLineList[i].itemCode);
		if (!error['itemCode_' + i].valid) {
			errorMessage = errorMessage + " <strong>" + (i + 1) + ". satırdaki Ürün Kodu " + error['itemCode_'  + i].message + "</strong><br/>";
		}

		error['edmItemName_'  + i] = validateField(undefined, "1,1000", inboxLineList[i].edmItemName);
		if (!error['edmItemName_' + i].valid) {
			errorMessage = errorMessage + " <strong>" + (i + 1) + ". satırdaki  e-Dönüşüm Ürün/Hizmet Adı" + error['edmItemName_'  + i].message + "</strong><br/>";
		}

		error['itemUnit_'  + i] = validateField(undefined, "1,10", inboxLineList[i].itemUnit);
		if (!error['itemUnit_' + i].valid) {
			errorMessage = errorMessage + " <strong>" + ". satırdaki Birim " + error['itemUnit_'  + i].message + "</strong><br/>";
		}
		//
		// error['currencyID_'  + i] = validateField(undefined, "1,3", inboxLineList[i].currencyID);
		// if (!error['currencyID_' + i].valid) {
		// 	errorMessage = errorMessage + " <strong>" + (i + 1) + ". satırdaki Para Birimi " + error['currencyID_'  + i].message + "</strong><br/>";
		// }
	}
	let valid = isValidObject(error);
	return {error, valid, errorMessage};
}

export function isValidMailProperty(mail) {
	let error = {};
	let errorMessage = "";

	error.protocol = validateField(undefined, "1,45", mail.protocol);
	if (!error.protocol.valid) {
		errorMessage = errorMessage + " <strong>Protocol bilgisi " + error.protocol.message + "</strong><br/>";
	}
	error.host = validateField(undefined, "1,45", mail.host);
	if (!error.host.valid) {
		errorMessage = errorMessage + " <strong>Host bilgisi " + error.host.message + "</strong><br/>";
	}
	error.port = validateField("integer", undefined, mail.port);
	if (!error.port.valid) {
		errorMessage = errorMessage + " <strong>Port bilgisi " + error.port.message + "</strong><br/>";
	}
	error.user = validateField("email", "1,255", mail.user);
	if (!error.user.valid) {
		errorMessage = errorMessage + " <strong>E-Posta/Kullanıcı Adı " + error.user.message + "</strong><br/>";
	}
	error.password = validateField(undefined, "1,45", mail.password);
	if (!error.password.valid) {
		errorMessage = errorMessage + " <strong>Şifre " + error.user.message + "</strong><br/>";
	}
	error.encryption = validateField(undefined, "0,45", mail.encryption);
	if (!error.encryption.valid) {
		errorMessage = errorMessage + " <strong>Şifreleme Türü " + error.encryption.message + "</strong><br/>";
	}
	error.signatureText = validateField(undefined, "0,255", mail.signatureText);
	if (!error.signatureText.valid) {
		errorMessage = errorMessage + " <strong>İmza Metni " + error.signatureText.message + "</strong><br/>";
	}
	let valid = isValidObject(error);
	return {error: error, valid: valid, errorMessage: errorMessage};
}

export function isValidSmsProperty(sms){
	let error = {};
	let errorMessage = "";

	error.username = validateField(undefined, "1,255", sms.username);
	if (!error.username.valid) {
		errorMessage = errorMessage + " <strong>Kullanıcı Adı bilgisi " + error.username.message + "</strong><br/>";
	}

	error.password = validateField(undefined, "1,100", sms.password);
	if (!error.password.valid) {
		errorMessage = errorMessage + " <strong>Şifre  bilgisi " + error.password.message + "</strong><br/>";
	}

	error.header = validateField(undefined, "1,13", sms.header);
	if (!error.header.valid) {
		errorMessage = errorMessage + " <strong>Header bilgisi " + error.header.message + "</strong><br/>";
	}

	error.providerType = validateField(undefined, "1,100", sms.providerType);
	if (!error.providerType.valid) {
		errorMessage = errorMessage + " <strong>Sağlayıcı bilgisi " + error.providerType.message + "</strong><br/>";
	}

	let valid = isValidObject(error);
	return {error: error, valid: valid, errorMessage: errorMessage};
}

export function isValidStock(stock,isGtipRequired) {
	let error = {};
	if (!showBaro())
		error.code = validateField(undefined, "1,45", stock.code);
	error.manufacturersItemIdentification = validateField(undefined, "0,45", stock.manufacturersItemIdentification);
	error.buyersItemIdentification = validateField(undefined, "0,45", stock.buyersItemIdentification);
	error.name = validateField(undefined, "1,200", stock.name);
	error.defaultCurrencyCode = validateField(undefined, "1,10", stock.defaultCurrencyCode);
	error.baseUnit = validateField(undefined, "1,10", stock.baseUnit);
	error.explanation = validateField(undefined, "0,200", stock.explanation);
	error.alias = validateField(undefined, "0,255", stock.alias);
	error.kdvPurchase = validateField("number", "1,45", stock.kdvPurchase);
	error.kdvSell = validateField("number", "1,45", stock.kdvSell);
	error.gvStoppagePurchase = validateField("number", "0,45", stock.gvStoppagePurchase);
	error.gvStoppageSell = validateField("number", "0,45", stock.gvStoppageSell);
	error.defPricePurchase = validateField("decimal", "1,45", stock.defPricePurchase);
	error.defPriceSell = validateField("decimal", "1,45", stock.defPriceSell);
	error.gtip = validateField("gtip", ((isGtipRequired===true || stock.gtip)?"12,12":"0,12"), stock.gtip);
	let valid = isValidObject(error);
	return {error: error, valid: valid};
}

export function isValidVersion(data){
	let error = {};

	error.versionNo = validateField(undefined, "1,20", data.versionNo);
	error.title = validateField(undefined, "1,200", data.title);
	error.showOn = validateField(undefined, "1,1000", data.showOn);

	let valid = isValidObject(error);
	return {error: error, valid: valid};
}

export function isValidFinancial(data) {
	let error = {};
	error.kullaniciAd = validateFinancialField('string', "2,50", data.kullaniciAd, "Ad");
	error.kullaniciSoyad = validateFinancialField('string', "2,50", data.kullaniciSoyad, "Soyad");
	error.kullaniciKimlikNo = validateFinancialField('identifier', "10,11", data.kullaniciKimlikNo, "TC Kimlik No");
	error.vergiDairesi = validateFinancialField('vergiDairesi', "2,40", data.vergiDairesi, "Vergi Dairesi");
	error.kullaniciDogumTarihi = validateFinancialField('date', "1,255", data.kullaniciDogumTarihi, "Doğum Tarihi");
	error.kullaniciDogumYeri = validateFinancialField('string', "3,100", data.kullaniciDogumYeri, "Doğum Yeri");
	error.mobilOperatorTipi = validateFinancialField(undefined, "1,1", data.mobilOperatorTipi, "Mobil Operatör");
	error.kullaniciIsTelefonu = validateFinancialField("telephone", "10,10", data.kullaniciIsTelefonu, "İş Telefonu");
	error.kullaniciCepTelefonu = validateFinancialField("telephone", "10,10", data.kullaniciCepTelefonu, "Cep Telefonu");
	error.bilgiKanali = validateFinancialField(undefined, "1,1", data.bilgiKanali, "Bilgi Kanalı");
	error.kullaniciAdresi = validateFinancialField("adres", "20,255", data.kullaniciAdresi, "Adres");
	error.kullaniciIl = validateFinancialField(undefined, "1,255", data.kullaniciIl, "İl");
	error.kullaniciIlce = validateFinancialField(undefined, "1,255", data.kullaniciIlce, "İlçe");
	error.kullaniciIletisimEposta = validateFinancialField("email", "2,255", data.kullaniciIletisimEposta, "E-Posta");
	error.kullaniciVergiNo = validateFinancialField(((data.tuzel === 1) ?  "vergiKimlikNo" : undefined), ((data.tuzel === 1) ? "10,10":"0,10"), data.kullaniciVergiNo, "Vergi Kimlik No");

	let valid = isValidObject(error);
	return {error: error, valid: valid};
}

export function isValidReportDelivery(data) {
	let error = {};
	error.teslimEdilenAdSoyad = validateFinancialField('string', "2,50", data.teslimEdilenAdSoyad, "Ad Soyad");
	error.teslimEdilenTckn = validateFinancialField('identifier', "10,11", data.teslimEdilenTckn, "TC Kimlik No");
	error.teslimEdilenTelefon = validateFinancialField("telephone", "10,10", data.teslimEdilenTelefon, "Telefon");

	let valid = isValidObject(error);
	return {error: error, valid: valid};
}

export function isValidCari(cari) {
	let error = {};
	let errorMessage = "";
	error.vknTckn = validateField(undefined, "1,11", cari.vknTckn);
	if (!error.vknTckn.valid) {
		errorMessage = errorMessage + " <strong>VKN/TCKN " + error.vknTckn.message + "</strong><br/>";
	}
	error.formattedName = validateField(undefined, "1,100", cari.formattedName);
	if (!error.formattedName.valid) {
		errorMessage = errorMessage + " <strong>Ünvan " + error.formattedName.message + "</strong><br/>";
	}
	error.cariCode = validateField(undefined, "1,5", cari.cariCode);
	if (!error.cariCode.valid) {
		errorMessage = errorMessage + " <strong>Cari Kodu " + error.cariCode.message + "</strong><br/>";
	}
	error.city = validateField(undefined, "1,20", cari.city);
	if (!error.city.valid) {
		errorMessage = errorMessage + " <strong>İl " + error.city.message + "</strong><br/>";
	}
	error.citySubdivision = validateField(undefined, "1,20", cari.citySubdivision);
	if (!error.citySubdivision.valid) {
		errorMessage = errorMessage + " <strong>İlçe " + error.citySubdivision.message + "</strong><br/>";
	}
	error.country = validateField(undefined, "1,20", cari.country);
	if (!error.country.valid) {
		errorMessage = errorMessage + " <strong>Ülke " + error.country.message + "</strong><br/>";
	}
	error.phone = validateField(undefined, "1,20", cari.phone);
	if (!error.phone.valid) {
		errorMessage = errorMessage + " <strong>Telefon " + error.phone.message + "</strong><br/>";
	}
	error.streetName = validateField(undefined, "1,100", cari.streetName);
	if (!error.streetName.valid) {
		errorMessage = errorMessage + " <strong>Cadde/Sokak " + error.streetName.message + "</strong><br/>";
	}
	error.taxOffice = validateField(undefined, "1,45", cari.taxOffice);
	if (!error.taxOffice.valid) {
		errorMessage = errorMessage + " <strong>Cadde/Sokak " + error.taxOffice.message + "</strong><br/>";
	}
	let valid = isValidObject(error);
	return {error, valid,errorMessage};
}

export function isValidERPStock(stock) {
	let error = {};
	let errorMessage = "";
	error.stockType = validateField(undefined, "1,10", stock.stockType);
	if (!error.stockType.valid) {
		errorMessage = errorMessage + " <strong>Stok tipi zorunludur, \'Ürün\', \'Hizmet\' değerlerinden biri olmalıdır.</strong><br/>";
	}
	error.itemCode = validateField(undefined, "1,45", stock.itemCode);
	if (!error.itemCode.valid) {
		errorMessage = errorMessage + " <strong>Ürün kodu " + error.itemCode.message + "</strong><br/>";
	}
	error.itemName = validateField(undefined, "1,255", stock.itemName);
	if (!error.itemName.valid) {
		errorMessage = errorMessage + " <strong>Ürün Adı " + error.itemName.message + "</strong><br/>";
	}
	error.itemUnit = validateField(undefined, "1,5", stock.itemUnit);
	if (!error.itemUnit.valid) {
		errorMessage = errorMessage + " <strong>Ürün Birim Kodu " + error.itemUnit.message + "</strong><br/>";
	}
	error.edmItemName = validateField(undefined, "1,255", stock.edmItemName);
	if (!error.edmItemName.valid) {
		errorMessage = errorMessage + " <strong>e-Dönüşüm Ürün Adı " + error.edmItemName.message + "</strong><br/>";
	}
	let valid = isValidObject(error);
	return {error, valid,errorMessage};
}

export function isValidMgmDetail(originCountryCode, classificationType, classificationValue) {
	let error = {};
	let errorMessage = "";

	error.originCountryCode = validateField(undefined, "0,45", originCountryCode);
	if (!error.originCountryCode.valid) {
		errorMessage = errorMessage + " <strong>MGM Ek Bilgiler->Ürün Menşei " + error.originCountryCode.message + "</strong><br/>";
	}

	error.classificationType = validateField(undefined, "0,45", classificationType);
	if (!error.classificationType.valid) {
		errorMessage = errorMessage + " <strong>MGM Ek Bilgiler->Sınıflama Türü " + error.classificationType.message + "</strong><br/>";
	}

	error.classificationValue = validateField(undefined, "0,45", classificationValue);
	if (!error.classificationValue.valid) {
		errorMessage = errorMessage + " <strong>MGM Ek Bilgiler->Sınıflama Kodu " + error.classificationValue.message + "</strong><br/>";
	}

	let valid = isValidObject(error);
	return {error: error, valid: valid, errorMessage: errorMessage};

}

export function isValidDeliveryDetail(deliveryDetail) {
	let error = {};
	let errorMessage = "";
	error.actualPackagePTC = validateField(undefined, "1,45", deliveryDetail ? deliveryDetail.actualPackagePTC : "");
	if (!error.actualPackagePTC.valid) {
		errorMessage = errorMessage + " <strong>Teslimat Bilgileri->Paket/Kutu Türü " + error.actualPackagePTC.message + "</strong><br/>";
	}
	error.actualPackageQuantity = validateField("number", "0,45", deliveryDetail ? deliveryDetail.actualPackageQuantity : "");
	if (!error.actualPackageQuantity.valid) {
		errorMessage = errorMessage + " <strong>Teslimat Bilgileri->Paket/Kutu Adedi " + error.actualPackageQuantity.message + "</strong><br/>";
	}
	error.city = validateField(undefined, "1,45", deliveryDetail ? deliveryDetail.city : "");
	if (!error.city.valid) {
		errorMessage = errorMessage + " <strong>Teslimat Bilgileri->Teslimat İli " + error.city.message + "</strong><br/>";
	}
	error.citySubdivion = validateField(undefined, "1,45", deliveryDetail ? deliveryDetail.citySubdivion : "");
	if (!error.citySubdivion.valid) {
		errorMessage = errorMessage + " <strong>Teslimat Bilgileri->Teslimat İlçesi " + error.citySubdivion.message + "</strong><br/>";
	}
	error.country = validateField(undefined, "1,255", deliveryDetail ? deliveryDetail.country : "");
	if (!error.country.valid) {
		errorMessage = errorMessage + " <strong>Teslimat Bilgileri->Teslimat Ülkesi " + error.country.message + "</strong><br/>";
	}
	error.deliveryTerms = validateField(undefined, "1,255", deliveryDetail ? deliveryDetail.deliveryTerms : "");
	if (!error.deliveryTerms.valid) {
		errorMessage = errorMessage + " <strong>Teslimat Bilgileri->Teslimat Şartı " + error.deliveryTerms.message + "</strong><br/>";
	}
	error.gtip = validateField("gtip", "1,12", deliveryDetail ? deliveryDetail.gtip : "");
	if (!error.gtip.valid) {
		errorMessage = errorMessage + " <strong>Teslimat Bilgileri->GTİP Numarası " + error.gtip.message + "</strong><br/>";
	}
	error.shipmentId = validateField(undefined, "1,45", deliveryDetail ? deliveryDetail.shipmentId : "");
	if (!error.shipmentId.valid) {
		errorMessage = errorMessage + " <strong>Teslimat Bilgileri->Kargo No " + error.shipmentId.message + "</strong><br/>";
	}
	error.transportModeCode = validateField(undefined, "1,45", deliveryDetail ? deliveryDetail.transportModeCode : "");
	if (!error.transportModeCode.valid) {
		errorMessage = errorMessage + " <strong>Teslimat Bilgileri->Teslimat Gönderim Şekli " + error.transportModeCode.message + "</strong><br/>";
	}
	let valid = isValidObject(error);
	return {error: error, valid: valid, errorMessage: errorMessage};
}

export function isValidExpenseNoteLine(expenseNoteLine){
	let error = {};
	let errorMessage = "";

	error.itemName = validateField(undefined, "1,1000", expenseNoteLine.itemName);
	if (!error.itemName.valid) {
		errorMessage = errorMessage + " <strong>Ürün Adı " + error.itemName.message + "</strong><br/>";
	}

	let charges = expenseNoteLine.trdDocExpenseNoteLineCharges;
	for (let i = 0; i < charges.length; i++) {
		if (charges[i].percentage !== "") {
			if (charges[i].taxCode.code === "0015" &&
				((new Decimal(charges[i].percentage)).eq(new Decimal(0)) || (new Decimal(charges[i].amount)).equals(new Decimal(0)))) {
				error.kdvExemption = validateField(undefined, "1,10", charges[i].exemptionReasonCode);
				if (!error.kdvExemption.valid) {
					errorMessage = errorMessage + " <strong>KDV Değeri Sıfır iken KDV istisna sebebi boş bırakılamaz.</strong><br/>";
				}
			} else if (charges[i].taxCode.code === "0071" && ((new Decimal(charges[i].percentage)).eq(new Decimal(0)) || (new Decimal(charges[i].amount)).equals(new Decimal(0)))) {
				error.otvExemption = validateField(undefined, "1,10", charges[i].exemptionReasonCode);
				if (!error.otvExemption.valid) {
					errorMessage = errorMessage + " <strong>ÖTV Değeri Sıfır iken ÖTV istisna sebebi boş bırakılamaz.</strong><br/>";
				}
			}
		}
	}
	let valid = isValidObject(error);
	return {error: error, valid: valid, errorMessage: errorMessage};
}

export function isValidInvoiceLine(invoiceLine, profileId, invoiceTypeCode, isKamu) {
	let error = {};
	let errorMessage = "";
	if (profileId === "IHRACAT") {
		let deliveryDetail = invoiceLine.trdDocInvoiceLineDeliveryDetail;
		error.actualPackagePTC = validateField(undefined, "1,45", deliveryDetail ? deliveryDetail.actualPackagePTC : "");
		if (!error.actualPackagePTC.valid) {
			errorMessage = errorMessage + " <strong>Teslimat Bilgileri->Paket/Kutu Türü " + error.actualPackagePTC.message + "</strong><br/>";
		}
		error.actualPackageQuantity = validateField("number", "0,45", deliveryDetail ? deliveryDetail.actualPackageQuantity : "");
		if (!error.actualPackageQuantity.valid) {
			errorMessage = errorMessage + " <strong>Teslimat Bilgileri->Paket/Kutu Adedi " + error.actualPackageQuantity.message + "</strong><br/>";
		}
		error.city = validateField(undefined, "1,45", deliveryDetail ? deliveryDetail.city : "");
		if (!error.city.valid) {
			errorMessage = errorMessage + " <strong>Teslimat Bilgileri->Teslimat İli " + error.city.message + "</strong><br/>";
		}
		error.citySubdivion = validateField(undefined, "1,45", deliveryDetail ? deliveryDetail.citySubdivion : "");
		if (!error.citySubdivion.valid) {
			errorMessage = errorMessage + " <strong>Teslimat Bilgileri->Teslimat İlçesi " + error.citySubdivion.message + "</strong><br/>";
		}
		error.country = validateField(undefined, "1,255", deliveryDetail ? deliveryDetail.country : "");
		if (!error.country.valid) {
			errorMessage = errorMessage + " <strong>Teslimat Bilgileri->Teslimat Ülkesi " + error.country.message + "</strong><br/>";
		}
		error.deliveryTerms = validateField(undefined, "1,255", deliveryDetail ? deliveryDetail.deliveryTerms : "");
		if (!error.deliveryTerms.valid) {
			errorMessage = errorMessage + " <strong>Teslimat Bilgileri->Teslimat Şartı " + error.deliveryTerms.message + "</strong><br/>";
		}
		error.gtip = validateField("gtip", "12,12", deliveryDetail ? deliveryDetail.gtip : "");
		if (!error.gtip.valid) {
			errorMessage = errorMessage + " <strong>Teslimat Bilgileri->GTİP Numarası " + error.gtip.message + "</strong><br/>";
		}
		error.shipmentId = validateField(undefined, "1,45", deliveryDetail ? deliveryDetail.shipmentId : "");
		if (!error.shipmentId.valid) {
			errorMessage = errorMessage + " <strong>Teslimat Bilgileri->Kargo No " + error.shipmentId.message + "</strong><br/>";
		}
		error.transportModeCode = validateField(undefined, "1,45", deliveryDetail ? deliveryDetail.transportModeCode : "");
		if (!error.transportModeCode.valid) {
			errorMessage = errorMessage + " <strong>Teslimat Bilgileri->Teslimat Gönderim Şekli " + error.transportModeCode.message + "</strong><br/>";
		}
	}
	error.itemName = validateField(undefined, "1,1000", invoiceLine.itemName);
	if (!error.itemName.valid) {
		errorMessage = errorMessage + " <strong>Ürün Adı " + error.itemName.message + "</strong><br/>";
	}
	error.buyersItemIdentification = validateField(undefined, "0,45", invoiceLine.buyersItemIdentification);
	if (!error.buyersItemIdentification.valid) {
		errorMessage = errorMessage + " <strong>" + error.buyersItemIdentification.message + "</strong><br/>";
	}
	if (profileId === "IHRACAT" || profileId === "YOLCUBERABERFATURA") {
		error.gumrukTakipNo = validateField(undefined, "0,255", invoiceLine.gumrukTakipNo);
		if (!error.gumrukTakipNo.valid) {
			errorMessage = errorMessage + " <strong>Gümrük Takip No " + error.gumrukTakipNo.message + "</strong><br/>";
		}
	}

	if (invoiceLine.siparisDate && !invoiceLine.siparisNo) {
		error.siparisNo = {valid: false, message: 'Sipariş Tarihi girildiyse Sipariş Numarası zorunludur.'};
		errorMessage = errorMessage + " <strong>Sipariş Tarihi girildiyse Sipariş Numarası zorunludur.</strong><br/>";
	} else if (!invoiceLine.siparisDate && invoiceLine.siparisNo) {
		error.siparisDate = {valid: false, message: 'Sipariş Numarası girildiyse Sipariş Tarihi zorunludur.'};
		errorMessage = errorMessage + " <strong>Sipariş Numarası girildiyse Sipariş Tarihi zorunludur.</strong><br/>";
	} else if (!invoiceLine.siparisDate && !invoiceLine.siparisNo) {
		error = resetValidation(error, 'siparisDate');
		error = resetValidation(error, 'siparisNo');
	} else {
		error.siparisNo = validateField(undefined, "1,20", invoiceLine.siparisNo);
		if (!error.siparisNo.valid) {
			errorMessage = errorMessage + " <strong>Sipariş No " + error.siparisNo.message + "</strong><br/>";
		}
		error.siparisDate = validateField("date", undefined, moment(invoiceLine.siparisDate).format("DD-MM-YYYY"));
		if (!error.siparisDate.valid) {
			errorMessage = errorMessage + " <strong>" + error.siparisDate.message + "</strong><br/>";
		}
	}

	if (invoiceLine.despatchDate && !invoiceLine.despatchNo) {
		error.despatchNo = {valid: false, message: 'İrsaliye Tarihi girildiyse İrsaliye Numarası zorunludur.'};
		errorMessage = errorMessage + " <strong>İrsaliye Tarihi girildiyse İrsaliye Numarası zorunludur.</strong><br/>";
	} else if (!invoiceLine.despatchDate && invoiceLine.despatchNo) {
		error.despatchDate = {valid: false, message: 'Sipariş Numarası girildiyse Sipariş Tarihi zorunludur.'};
		errorMessage = errorMessage + " <strong>İrsaliye Numarası girildiyse İrsaliye Tarihi zorunludur.</strong><br/>";
	} else if (!invoiceLine.despatchDate && !invoiceLine.despatchNo) {
		error = resetValidation(error, 'despatchDate');
		error = resetValidation(error, 'despatchNo');
	} else {
		error.despatchNo = validateField(undefined, "1,20", invoiceLine.despatchNo);
		if (!error.despatchNo.valid) {
			errorMessage = errorMessage + " <strong>İrsaliye No " + error.despatchNo.message + "</strong><br/>";
		}
		error.despatchDate = validateField("date", undefined, moment(invoiceLine.despatchDate).format("DD-MM-YYYY"));
		if (!error.despatchDate.valid) {
			errorMessage = errorMessage + " <strong>" + error.despatchDate.message + "</strong><br/>";
		}
	}

	if (isKamu) {
		let result = isValidMgmDetail(invoiceLine.originCountryCode, invoiceLine.classificationType, invoiceLine.classificationValue);
		error = Object.assign(error, result.error)
		errorMessage = errorMessage + result.errorMessage;
	}

	let charges = invoiceLine.trdDocInvoiceLineCharges;
	for (let i = 0; i < charges.length; i++) {
		if (charges[i].percentage !== "") {
			if (charges[i].taxCode.code === "9015") {
				if (invoiceTypeCode === "TEVKIFAT") {
					error.withholdingCode = validateField(undefined, "1,10", charges[i].withholdingCode);
					if (!error.withholdingCode.valid) {
						errorMessage = errorMessage + " <strong>Fatura tipi TEVKIFAT iken ve KDV TEVKİFAT Vergisi ekli iken Tevkifat Sebebi girilmelidir.</strong><br/>";
					}
				}
			} else if (charges[i].taxCode.code === "0015" &&
				((new Decimal(charges[i].percentage)).eq(new Decimal(0)) || (new Decimal(charges[i].amount)).equals(new Decimal(0)))
				&& profileId !== 'IHRACAT' && invoiceTypeCode !== 'KONAKLAMAVERGISI') {
				error.kdvExemption = validateField(undefined, "1,10", charges[i].exemptionReasonCode);
				if (!error.kdvExemption.valid) {
					errorMessage = errorMessage + " <strong>KDV Değeri Sıfır iken KDV istisna sebebi boş bırakılamaz.</strong><br/>";
				}
			} else if (charges[i].taxCode.code === "0071" && ((new Decimal(charges[i].percentage)).eq(new Decimal(0)) || (new Decimal(charges[i].amount)).equals(new Decimal(0)))) {
				error.otvExemption = validateField(undefined, "1,10", charges[i].exemptionReasonCode);
				if (!error.otvExemption.valid) {
					errorMessage = errorMessage + " <strong>ÖTV Değeri Sıfır iken ÖTV istisna sebebi boş bırakılamaz.</strong><br/>";
				}
			}
		}
	}
	let valid = isValidObject(error);
	return {error: error, valid: valid, errorMessage: errorMessage};
}

export function isValidBelgeLine(belgeLine, profileId, documentTypeCode, isKamu) {
	let error = {};
	let errorMessage = "";
	error.itemName = validateField(undefined, "1,1000", belgeLine.itemName);
	if (!error.itemName.valid) {
		errorMessage = errorMessage + " <strong>Ürün Adı " + error.itemName.message + "</strong><br/>";
	}

	if (isKamu) {
		let result = isValidMgmDetail(belgeLine.originCountryCode, belgeLine.classificationType, belgeLine.classificationValue);
		error = Object.assign(error, result.error)
		errorMessage = errorMessage + result.errorMessage;
	}
	if (documentTypeCode === "ISTISNA") {
		if (belgeLine.gtip) {
			error.gtip = validateField("gtip", "12,12", belgeLine.gtip);

			if(!error.gtip.valid) {
				errorMessage = errorMessage + "<strong> Satır gtip numarası " + error.gtip.message + "<br/></strong>";
			}
		}
	}

	let charges = belgeLine.trdDocBelgeLineCharges;
	for (let i = 0; i < charges.length; i++) {
		if (charges[i].percentage !== "") {
			if (charges[i].taxCode.code === "9015") {
				if (documentTypeCode === "TEVKIFAT") {
					error.withholdingCode = validateField(undefined, "1,10", charges[i].withholdingCode);
					if (!error.withholdingCode.valid) {
						errorMessage = errorMessage + " <strong>Fatura tipi TEVKIFAT iken ve KDV TEVKİFAT Vergisi ekli iken Tevkifat Sebebi girilmelidir.</strong><br/>";
					}
				}
			} else if (charges[i].taxCode.code === "0015" &&
				((new Decimal(charges[i].percentage)).eq(new Decimal(0)) || (new Decimal(charges[i].amount)).equals(new Decimal(0)))
				&& profileId !== 'IHRACAT' && documentTypeCode !== 'KONAKLAMAVERGISI') {
				error.kdvExemption = validateField(undefined, "1,10", charges[i].exemptionReasonCode);
				if (!error.kdvExemption.valid) {
					errorMessage = errorMessage + " <strong>KDV Değeri Sıfır iken KDV istisna sebebi boş bırakılamaz.</strong><br/>";
				}
			} else if (charges[i].taxCode.code === "0071" && ((new Decimal(charges[i].percentage)).eq(new Decimal(0)) || (new Decimal(charges[i].amount)).equals(new Decimal(0)))) {
				error.otvExemption = validateField(undefined, "1,10", charges[i].exemptionReasonCode);
				if (!error.otvExemption.valid) {
					errorMessage = errorMessage + " <strong>ÖTV Değeri Sıfır iken ÖTV istisna sebebi boş bırakılamaz.</strong><br/>";
				}
			}
		}
	}
	let valid = isValidObject(error);
	return {error: error, valid: valid, errorMessage: errorMessage};
}

export function isValidExpenseNote(data) {
	let error = {};
	let errorMessage = "";
	let valid = isValidObject(error);
	return {error: error, valid: valid, errorMessage: errorMessage};
}

export function isValidNoIdentifier(data,requiredTaxOffice) {
	let error = {};
	let errorMessage = "";
	error.email = validateField("email", "0,255", data.email);
	if (!error.email.valid) {
		errorMessage = errorMessage + " <strong>E-Posta " + error.email.message + "</strong><br/>";
	}

	if(data.telephone && data.telephone.includes("_")){
		error.telephone = validateField("phone", undefined, data.telephone);
		if (!error.telephone.valid) {
			errorMessage = errorMessage + " <strong> " + error.telephone.message + "</strong><br/>";
		}
	}

	let length = (isset(data.vknTckn) ? data.vknTckn.length : 11);
	error.vknTckn = validateField(undefined, "1," + length, data.vknTckn);
	if (!error.vknTckn.valid) {
		errorMessage = errorMessage + " <strong>VKN/TCKN " + error.vknTckn.message + "</strong><br/>";
	}
	if (length === 11) {
		error.givenName = validateField(undefined, "1,45", data.givenName);
		if (!error.givenName.valid) {
			errorMessage = errorMessage + " <strong>Adı " + error.givenName.message + "</strong><br/>";
		}
		error.familyName = validateField(undefined, "1,45", data.familyName);
		if (!error.familyName.valid) {
			errorMessage = errorMessage + " <strong>Soyadı " + error.familyName.message + "</strong><br/>";
		}
	} else {
		error.formattedName = validateField(undefined, "2,350", data.formattedName);
		if (!error.formattedName.valid) {
			errorMessage = errorMessage + " <strong>Ünvan " + error.formattedName.message + "</strong><br/>";
		}
	}

	error.cityName = validateField(undefined, "1,255", data.cityName);
	if (!error.cityName.valid) {
		errorMessage = errorMessage + " <strong>İl " + error.cityName.message + "</strong><br/>";
	}

	error.citySubdivisionName = validateField(undefined, "1,255", data.citySubdivisionName);
	if (!error.citySubdivisionName.valid) {
		errorMessage = errorMessage + " <strong>İlçe " + error.citySubdivisionName.message + "</strong><br/>";
	}

	error.countryName = validateField(undefined, "1,255", data.countryName);
	if (!error.countryName.valid) {
		errorMessage = errorMessage + " <strong>Ülke " + error.countryName.message + "</strong><br/>";
	}

	if(requiredTaxOffice){
		error.taxOffice = validateField(undefined, "1,255", data.taxOffice);
		if (!error.taxOffice.valid) {
			errorMessage = errorMessage + " <strong>Vergi Dairesi " + error.taxOffice.message + "</strong><br/>";
		}
	}

	let valid = isValidObject(error);
	return {error: error, valid: valid, errorMessage: errorMessage};
}

export function isValidTouristInfo(touristInfo) {
	let error = {};
	error.firstName = validateField(undefined, "1,255", touristInfo ? touristInfo.firstName : "");
	error.familyName = validateField(undefined, "1,255", touristInfo ? touristInfo.familyName : "");
	error.touristCity = validateField(undefined, "1,255", touristInfo ? touristInfo.touristCity : "");
	error.touristCitySubdivision = validateField(undefined, "1,255", touristInfo ? touristInfo.touristCitySubdivision : "");
	error.touristCountry = validateField(undefined, "1,255", touristInfo ? touristInfo.touristCountry : "");
	error.touristNationality = validateField(undefined, "1,255", touristInfo ? touristInfo.touristNationality : "");
	error.touristPassportDate = validateField("dateDB", "1,255", touristInfo ? touristInfo.touristPassportDate : "");
	error.touristPassportNo = validateField(undefined, "1,255", touristInfo ? touristInfo.touristPassportNo : "");
	let valid = isValidObject(error);
	return {error: error, valid: valid};
}

export function isValidDespatchLine(despatchLine) {
	let error = {};
	let errorMessage = "";

	error['itemName'] = validateField(undefined, "1,1000", despatchLine.itemName);
	if (!error['itemName'].valid) {
		errorMessage = errorMessage + " <strong> Ürün/Hizmet " + error['itemName'].message + "</strong><br/>";
	}

	if (despatchLine && despatchLine.barcode && despatchLine.barcode !== "") {
		error['barcode'] = validateField(undefined, "13", despatchLine.barcode);
		if (!error['barcode'].valid) {
			errorMessage = errorMessage + " <strong> Barkod alanı " + error['barcode'].message + "</strong><br/>";
		}
	}
	let valid = isValidObject(error);
	return {
		error: error,
		valid: valid && !isset(errorMessage),
		errorMessage: errorMessage,
	};
}

export function isValidDespatch(data, activeTab, innerActiveTab) {
	let error = {};
	let errorMessage = "";
	let tActiveTab = "";
	let tInnerActiveTab = "";

	let externalCustomer = data.externalCustomer;
	let externalCustomerAddress = data.externalCustomerAddress;
	let tmpDocConnectorExCustomer = data.tmpDocConnectorExCustomer;
	let despatchTypeCode = data.despatchTypeCode;
	let cityName;
	let citySubdivisionName;
	let countryName;
	let email;
	let givenName;
	let familyName;
	let formattedName;
	let taxOffice;
	let vknTckn;

	if(data.from==='CONNECTOR'){
		vknTckn = tmpDocConnectorExCustomer.vknTckn
		cityName = tmpDocConnectorExCustomer.cityName
		citySubdivisionName = tmpDocConnectorExCustomer.citySubdivisionName
		countryName = tmpDocConnectorExCustomer.countryName
		givenName = tmpDocConnectorExCustomer.givenName
		familyName = tmpDocConnectorExCustomer.familyName
		formattedName = tmpDocConnectorExCustomer.formattedName
		taxOffice = tmpDocConnectorExCustomer.taxOffice

		error.vknTckn = validateField("identifier","10,11" ,vknTckn);
		if (!error.vknTckn.valid) {
			errorMessage = errorMessage + " <strong>Vkn/Tckn " + error.vknTckn.message + "</strong><br/>";
			tActiveTab = tActiveTab || "temelbilgiler";
		}
	}else{
		vknTckn = externalCustomer.vknTckn
		cityName = externalCustomerAddress.cityName
		citySubdivisionName = externalCustomerAddress.citySubdivisionName
		countryName = externalCustomerAddress.countryName
		givenName = externalCustomer.givenName
		familyName = externalCustomer.familyName
		formattedName = externalCustomer.formattedName
		taxOffice = externalCustomer.taxOffice
	}

	error.sourceUrn = validateField(undefined, "1,255", data.sourceUrn);
	if (!error.sourceUrn.valid) {
		errorMessage = errorMessage + " <strong>Gönderici Birim Etiketi " + error.sourceUrn.message + "</strong><br/>";
	}

	if(moment(data.despatchShipment.actualDespatchDatetime).isBefore(moment(data.issueDate),'days,hours')){
		errorMessage = errorMessage + "<strong>Sevk Tarihi İrsaliye Tarihinden Önce Olamaz</strong><br/>";
	}

	if (data.despatchParties !== null && data.despatchParties.length >0) {
		data.despatchParties.map(party =>{
			tInnerActiveTab = (party.partyType === "BUYER_CUSTOMER") ? "ht3" : "ht5";
			let text = (party.partyType === "BUYER_CUSTOMER") ? "Asıl Alıcı" : "Asıl Satıcı";
			error.partyIdentification = validateField("identifier", "10, 11", party.partyIdentification);
			if (!error.partyIdentification.valid) {
				errorMessage = errorMessage + "<strong>" + text + " Vkn/Tckn " + error.partyIdentification.message + "</strong><br/>";
				tActiveTab = tActiveTab || "digerbilgiler";
			}
			error.partyName = validateField(undefined, "0,255", party.partyName);
			if (!error.partyName.valid) {
				errorMessage = errorMessage + " <strong>" + text + " Ünvan " + error.partyName.message + "</strong><br/>";
				tActiveTab = tActiveTab || "digerbilgiler";
			}
			error.firstName = validateField(undefined, "0,100", party.firstName);
			if (!error.firstName.valid) {
				errorMessage = errorMessage + " <strong>" + text + " Adı " + error.firstName.message + "</strong><br/>";
				tActiveTab = tActiveTab || "digerbilgiler";
			}
			error.familyName = validateField(undefined, "0,100", party.familyName);
			if (!error.familyName.valid) {
				errorMessage = errorMessage + " <strong>" + text + " Soyadı " + error.familyName.message + "</strong><br/>";
				tActiveTab = tActiveTab || "digerbilgiler";
			}
		})
	}


	let length = (isset(vknTckn) ? vknTckn.length : 11);
	if (length === 11) {
		error.givenName = validateField(undefined, "1,45", givenName);
		if (!error.givenName.valid) {
			errorMessage = errorMessage + "<strong>Adı " + error.givenName.message + "</strong><br/>";
			tActiveTab = tActiveTab || "temelbilgiler";
		}
		error.familyName = validateField(undefined, "1,45", familyName);
		if (!error.familyName.valid) {
			errorMessage = errorMessage + "<strong>Soyadı " + error.familyName.message + "</strong><br/>";
			tActiveTab = tActiveTab || "temelbilgiler";
		}
	} else {
		error.formattedName = validateField(undefined, "1,255", formattedName);
		if (!error.formattedName.valid) {
			errorMessage = errorMessage + "<strong>Ünvan " + error.formattedName.message + "</strong><br/>";
			tActiveTab = tActiveTab || "temelbilgiler";
		}
	}

	error.taxOffice = validateField(undefined, "0,255", taxOffice);
	if (!error.taxOffice.valid) {
		errorMessage = errorMessage + " <strong>Vergi dairesi " + error.taxOffice.message + "</strong><br/>";
		tActiveTab = tActiveTab || "temelbilgiler";
	}

	error.cityName = validateField(undefined, "1,255", cityName);
	if (!error.cityName.valid) {
		errorMessage = errorMessage + " <strong>İl " + error.cityName.message + "</strong><br/>";
		tActiveTab = tActiveTab || "temelbilgiler";
	}

	error.citySubdivisionName = validateField(undefined, "1,255", citySubdivisionName);
	if (!error.citySubdivisionName.valid) {
		errorMessage = errorMessage + " <strong>İlçe " + error.citySubdivisionName.message + "</strong><br/>";
		tActiveTab = tActiveTab || "temelbilgiler";
	}

	error.countryName = validateField(undefined, "1,255", countryName);
	if (!error.countryName.valid) {
		errorMessage = errorMessage + " <strong>Ülke " + error.countryName.message + "</strong><br/>";
		tActiveTab = tActiveTab || "temelbilgiler";
	}

	if (data.orderReferenceDate && !data.orderReferenceNumber) {
		error.orderReferenceNumber = {valid: false, message: 'Sipariş Tarihi girildiyse Sipariş Numarası zorunludur.'};
		errorMessage = errorMessage + " <strong>Sipariş Tarihi girildiyse Sipariş Numarası zorunludur.</strong><br/>";
		tActiveTab = tActiveTab || "digerbilgiler";
		tInnerActiveTab = "ht1";
	} else if (!data.orderReferenceDate && data.orderReferenceNumber) {
		error.orderReferenceDate = {valid: false, message: 'Sipariş Numarası girildiyse Sipariş Tarihi zorunludur.'};
		errorMessage = errorMessage + " <strong>Sipariş Numarası girildiyse Sipariş Tarihi zorunludur.</strong><br/>";
		tActiveTab = tActiveTab || "digerbilgiler";
		tInnerActiveTab = "ht1";
	} else if (!data.orderReferenceDate && !data.orderReferenceNumber) {
		error = resetValidation(error, 'orderReferenceDate');
		error = resetValidation(error, 'orderReferenceNumber');
		//tActiveTab=tActiveTab || "digerbilgiler";tInnerActiveTab="ht1";
	} else {
		error.orderReferenceNumber = validateField(undefined, "1,20", data.orderReferenceNumber);
		if (!error.orderReferenceNumber.valid) {
			errorMessage = errorMessage + " <strong>Sipariş No " + error.orderReferenceNumber.message + "</strong><br/>";
			tActiveTab = tActiveTab || "digerbilgiler";
			tInnerActiveTab = "ht1";
		}
		error.orderReferenceDate = validateField("date", undefined, moment(data.orderReferenceDate).format("DD-MM-YYYY"));
		if (!error.orderReferenceDate.valid) {
			errorMessage = errorMessage + " <strong>" + error.orderReferenceDate.message + "</strong><br/>";
			tActiveTab = tActiveTab || "digerbilgiler";
			tInnerActiveTab = "ht1";
		}
	}

	if (data.despatchShipment.deliveryType === 'CARRIER') {
		error.carrierId = validateField("vkn", "1,10", data.despatchShipment.carrierId);
		if (!error.carrierId.valid) {
			errorMessage = errorMessage + (data.despatchShipment.carrierId !== null && data.despatchShipment.carrierId !== "" ? "<strong> Taşıyıcı " : "<strong> Taşıyıcı Vkn ") + error.carrierId.message + "</strong><br/>";
			tActiveTab = tActiveTab || "digerbilgiler";
			tInnerActiveTab = "ht2";
		}

		error.carrierTitle = validateField(undefined, "1,255", data.despatchShipment.carrierTitle);
		if (!error.carrierTitle.valid) {
			errorMessage = errorMessage + "<strong> Taşıyıcı Ünvan " + error.carrierTitle.message + "</strong><br/>";
			tActiveTab = tActiveTab || "digerbilgiler";
			tInnerActiveTab = "ht2";
		}

		if(data.despatchAdditionalDocuments){
			for(let i = 0; i < data.despatchAdditionalDocuments.length; i++){
				if (despatchTypeCode === "MATBUDAN" && !data.despatchAdditionalDocuments[i].content) {
					error.despatchAdditionalDocuments = {valid: false, message: 'İrsaliye Tipi MATBUDAN ise Ekbelge eklemek zorunludur'};
					errorMessage = errorMessage + " <strong>İrsaliye Tipi MATBUDAN ise Ekbelge eklemek zorunludur.</strong><br/>";
					tActiveTab = tActiveTab || "digerbilgiler";
				}
				let today = new Date();
				let date = new Date(data.despatchAdditionalDocuments[i].issueDate);
				if(despatchTypeCode === "MATBUDAN" && data.despatchAdditionalDocuments[i].issueDate === null){
					error.despatchAdditionalDocuments = {valid: false, message: 'İrsaliye Ek-belge tarihi boş bırakılamaz.'};
					errorMessage = errorMessage + " <strong>İrsaliye Ek-belge tarihi boş bırakılamaz.</strong><br/>";
					tActiveTab = tActiveTab || "digerbilgiler";
				} else if(despatchTypeCode === "MATBUDAN" && date > today){
					error.despatchAdditionalDocuments = {valid: false, message: 'İrsaliye Ek-belge tarihi ileri tarihli olamaz.'};
					errorMessage = errorMessage + " <strong>İrsaliye Ek-belge tarihi ileri tarihli olamaz.</strong><br/>";
					tActiveTab = tActiveTab || "digerbilgiler";
				}
				if(despatchTypeCode === "MATBUDAN" && data.despatchAdditionalDocuments[i].documentId === null){
					error.despatchAdditionalDocuments = {valid: false, message: 'İrsaliye Ek-belge Seri-Sıra Numarası boş bırakılamaz.'};
					errorMessage = errorMessage + " <strong>İrsaliye Ek-belge Seri-Sıra Numarası boş bırakılamaz.</strong><br/>";
					tActiveTab = tActiveTab || "digerbilgiler";
				}
			}
		} else if (despatchTypeCode === "MATBUDAN") {
			error.despatchAdditionalDocuments = {valid: false, message: 'İrsaliye Tipi MATBUDAN ise Ekbelge eklemek zorunludur'};
			errorMessage = errorMessage + " <strong>İrsaliye Tipi MATBUDAN ise Ekbelge eklemek zorunludur.</strong><br/>";
			tActiveTab = tActiveTab || "digerbilgiler";
		}

		// error.carrierTitle = validateCustom(!!data.despatchShipment.carrierTitle, 'Taşıyıcı Ünvanı zorunludur.')
		// if(!error.carrierTitle.valid){
		// 	errorMessage = errorMessage + "<strong>"+error.carrierTitle.message+"</strong><br/>";
		// 	tActiveTab=tActiveTab || "digerbilgiler";tInnerActiveTab="ht2";
		// }
	} else if (data.despatchShipment.deliveryType === 'DRIVER') {
		if (data.despatchShipment.driverInfos && data.despatchShipment.driverInfos.length > 0) {
			let driverInfos = data.despatchShipment.driverInfos;
			for (let i = 0; i < driverInfos.length; i++) {
				error['driverFirstName_' + i] = validateField(undefined, "1,45", driverInfos[i].firstName);
				if (!error['driverFirstName_' + i].valid) {
					errorMessage = errorMessage + "<strong>Şoför Adı " + error['driverFirstName_' + i].message + "</strong><br/>";
					tActiveTab = tActiveTab || "digerbilgiler";
					tInnerActiveTab = "ht2";
				}

				error['driverFamilyName_' + i] = validateField(undefined, "1,45", driverInfos[i].familyName);
				if (!error['driverFamilyName_' + i].valid) {
					errorMessage = errorMessage + "<strong>Şoför Soyadı " + error['driverFamilyName_' + i].message + "</strong><br/>";
					tActiveTab = tActiveTab || "digerbilgiler";
					tInnerActiveTab = "ht2";
				}

				error['driverIdentity_' + i] = validateField(undefined, "1,11", driverInfos[i].identityCardNo);
				if (!error['driverIdentity_' + i].valid) {
					errorMessage = errorMessage + "<strong>Şoför TCKN " + error['driverIdentity_' + i].message + "</strong><br/>";
					tActiveTab = tActiveTab || "digerbilgiler";
					tInnerActiveTab = "ht2";
				}
			}
		} else {
			error.driverValidation = validateCustom(false, "En az bir sürücü eklemelisiniz.");
			if (!error.driverValidation.valid) {
				errorMessage = errorMessage + "<strong>" + error.driverValidation.message + "</strong><br/>";
				tActiveTab = tActiveTab || "digerbilgiler";
				tInnerActiveTab = "ht2";
			}
		}
	} else {
		// impossible block you've fallen into. you shall die.
	}

	error.transportId = validateField(undefined, "0,100", data.despatchShipment.transportId);
	if (!error.transportId.valid) {
		errorMessage = errorMessage + "<strong>" + error.transportId.message + "</strong><br/>";
		tActiveTab = tActiveTab || "digerbilgiler";
		tInnerActiveTab = "ht2";
	}

	error.actualDespatchDatetime = validateCustom(!!data.despatchShipment.actualDespatchDatetime, "Sevk Tarihi girilmesi zorunludur.");
	if (!error.actualDespatchDatetime.valid) {
		errorMessage = errorMessage + "<strong>" + error.actualDespatchDatetime.message + "</strong><br/>";
		tActiveTab = tActiveTab || "digerbilgiler";
		tInnerActiveTab = "ht2";
	}

	if (!!data.despatchShipment.actualDespatchDatetime) {
		error.actualDespatchDatetime = validateField("datetime", undefined, moment(data.despatchShipment.actualDespatchDatetime).format("DD-MM-YYYY HH:mm:ss"));
		if (!error.actualDespatchDatetime.valid) {
			errorMessage = errorMessage + "<strong>" + error.actualDespatchDatetime.message + "</strong><br/>";
			tActiveTab = tActiveTab || "digerbilgiler";
			tInnerActiveTab = "ht2";
		}
	}

	error.deliveryCity = validateCustom(!!data.despatchShipment.deliveryCity, "Teslimat Şehri alanı boş bırakılamaz");
	if(!error.deliveryCity.valid) {
		errorMessage = errorMessage + "<strong>" + error.deliveryCity.message + "</strong><br/>";
		tActiveTab=tActiveTab || "digerbilgiler";tInnerActiveTab="ht0";
	}

	error.deliveryCitySubdivision = validateCustom(!!data.despatchShipment.deliveryCitySubdivision, "Teslimat İlçesi alanı boş bırakılamaz");
	if(!error.deliveryCitySubdivision.valid) {
		errorMessage = errorMessage + "<strong>" + error.deliveryCitySubdivision.message + "</strong><br/>";
		tActiveTab=tActiveTab || "digerbilgiler";tInnerActiveTab="ht0";
	}

	error.deliveryRegion = validateField(undefined,"0,255", data.despatchShipment.deliveryRegion);
	if(!error.deliveryRegion.valid) {
		errorMessage = errorMessage + "<strong>Teslimat Bilgileri->Kasaba/Köy" + error.deliveryRegion.message + "</strong><br/>";
		tActiveTab=tActiveTab || "digerbilgiler";tInnerActiveTab="ht0";
	}

	error.deliveryStreet = validateField(undefined,"0,255", data.despatchShipment.deliveryStreet);
	if(!error.deliveryStreet.valid) {
		errorMessage = errorMessage + "<strong>Teslimat Bilgileri->Mah./Cad./Sokak " + error.deliveryStreet.message + "</strong><br/>";
		tActiveTab=tActiveTab || "digerbilgiler";tInnerActiveTab="ht0";
	}

	error.deliveryBuildingName = validateField(undefined,"0,100", data.despatchShipment.deliveryBuildingName);
	if(!error.deliveryBuildingName.valid) {
		errorMessage = errorMessage + "<strong>Teslimat Bilgileri->Bina Adı " + error.deliveryBuildingName.message + "</strong><br/>";
		tActiveTab=tActiveTab || "digerbilgiler";tInnerActiveTab="ht0";
	}

	error.deliveryBuildingNumber = validateField(undefined, "0,45", data.despatchShipment.deliveryBuildingNumber);
	if(!error.deliveryBuildingNumber.valid) {
		errorMessage = errorMessage +  " <strong>Teslimat Bilgileri->Bina No " + error.deliveryBuildingNumber.message + "</strong><br/>";
		tActiveTab = tActiveTab || "digerbilgiler";
		tInnerActiveTab = "ht0";
	}

	error.deliveryRoomNumber = validateField(undefined,"0,45", data.despatchShipment.deliveryRoomNumber);
	if(!error.deliveryRoomNumber.valid) {
		errorMessage = errorMessage + "<strong>Teslimat Bilgileri->Kapı No " +error.deliveryRoomNumber.message + "</strong><br/>";
		tActiveTab=tActiveTab || "digerbilgiler";tInnerActiveTab="ht0";
	}

	error.bayiNo = validateField(undefined,"0,45", data.despatchShipment.bayiNo);
	if(!error.bayiNo.valid) {
		errorMessage = errorMessage + "<strong>Teslimat Bilgileri->Bayi No " +error.bayiNo.message + "</strong><br/>";
		tActiveTab=tActiveTab || "digerbilgiler";tInnerActiveTab="ht0";
	}

	error.subeNo = validateField(undefined,"0,45", data.despatchShipment.subeNo);
	if(!error.subeNo.valid) {
		errorMessage = errorMessage + "<strong>Teslimat Bilgileri->Şube No " + error.subeNo.message + "</strong><br/>";
		tActiveTab=tActiveTab || "digerbilgiler";tInnerActiveTab="ht0";
	}

	error.deliveryCountry = validateCustom(!!data.despatchShipment.deliveryCountry, "Teslimat Ülkesi alanı boş bırakılamaz");
	if(!error.deliveryCountry.valid) {
		errorMessage = errorMessage + "<strong>" + error.deliveryCountry.message + "</strong><br/>";
		tActiveTab=tActiveTab || "digerbilgiler";tInnerActiveTab="ht0";
	}

	error.deliveryPostalZone = validateField("deliveryPostalZone", undefined, data.despatchShipment.deliveryPostalZone);
	if(!error.deliveryPostalZone.valid) {
		errorMessage = errorMessage + "<strong>" + error.deliveryPostalZone.message + "</strong><br/>";
		tActiveTab=tActiveTab || "digerbilgiler";tInnerActiveTab="ht0";
	}

	error.lineExtensionAmount = validateField("decimal", undefined, data.lineExtensionAmount);
	error.payableAmount = validateField("decimal", undefined, data.payableAmount);
	if (data.documentCurrencyCode !== "TRY") {
		error.paymentExchangeRate = validateField("decimal", undefined, data.paymentExchangeRate);
	}

	let despatchLines = data.despatchLines;
	for (let i = 0; i < despatchLines.length; i++) {
		error['itemName_' + i] = validateField(undefined, "1,1000", despatchLines[i].itemName);
		if (!error['itemName_' + i].valid) {
			errorMessage = errorMessage + " <strong>" + (i + 1) + ". satırdaki Ürün/Hizmet " + error['itemName_' + i].message + "</strong><br/>";
		}
		if (new Decimal(despatchLines[i].quantity).eq(0.00)) {
			errorMessage = errorMessage + (i + 1) + " .<strong> satırdaki miktar 0 olamaz.<br/></strong>";
		}
	}
	if(data.profileId === 'HKSIRSALIYE'){
		for (let i = 0; i < despatchLines.length; i++) {
			error['kunyeNo_' + i] = validateField(undefined, "19", despatchLines[i].kunyeNo);
			if (!error['kunyeNo_' + i].valid) {
				errorMessage = errorMessage + " <strong>" + (i + 1) + ". satırdaki Künye Numarası " + error['kunyeNo_' + i].message + "</strong><br/>";
			}
		}
	}

	let valid = isValidObject(error);
	return {
		error: error,
		valid: valid && !isset(errorMessage),
		errorMessage: errorMessage,
		activeTab: (tActiveTab || activeTab),
		hTabs: (tInnerActiveTab || innerActiveTab)
	};
}

export function resetValidation(error, fieldName) {
	error[fieldName] = {valid: true, message: ''};
	return error;
}

export function isValidMReport(data) {
	let error = {};
	let errorMessage = "";

	error.salesTotalAmount = validateField("decimal", "1,20", data.salesTotalAmount);
	if (!error.salesTotalAmount.valid) {
		errorMessage = errorMessage + " <strong>Satış Toplamı " + error.salesTotalAmount.message + "</strong><br/>";
	}
	error.reportNumber = validateField("uuid", "1,36", data.reportNumber);
	if (!error.reportNumber.valid) {
		errorMessage = errorMessage + " <strong>Raporu Numarası " + error.reportNumber.message + "</strong><br/>";
	}
	error.serialNumber = validateField(undefined, "1,20", data.serialNumber);
	if (!error.serialNumber.valid) {
		errorMessage = errorMessage + " <strong>ÖKC Seri Numarası " + error.serialNumber.message + "</strong><br/>";
	}

	error.periodEndDate = validateField("periodDate", "1,20", data.periodEndDate);
	if (!error.periodEndDate.valid) {
		errorMessage = errorMessage + " <strong>ÖKC Dönem Bilgisi " + error.periodEndDate.message + "</strong><br/>";
	}

	if (data.reportType === "ymRapor") {
		error.brand = validateField("brand", "1,45", data.brand);
		if (!error.brand.valid) {
			errorMessage = errorMessage + " <strong>ÖKC Marka Bilgisi " + error.brand.message + "</strong><br/>";
		}

		error.model = validateField("model", "1,45", data.model);
		if (!error.model.valid) {
			errorMessage = errorMessage + " <strong>ÖKC Model Bilgisi " + error.model.message + "</strong><br/>";
		}

		error.monthlySalesReportNumber = validateField("monthlySalesReportNumber", "1,45", data.monthlySalesReportNumber);
		if (!error.monthlySalesReportNumber.valid) {
			errorMessage = errorMessage + " <strong>ÖKC Aylık Satış Rapor No Bilgisi " + error.monthlySalesReportNumber.message + "</strong><br/>";
		}
	}

	let valid = isValidObject(error);
	return {error: error, valid: (valid && !errorMessage), errorMessage: errorMessage};
}

export function isValidDbsAuth(data, type) {
	let error = {};
	let errorMessage = "";
	if(data.loginType === 'ASSOS' || type === AuthPageType.INTERAKTIFVD){
		error.username = validateField(undefined, "1,45", data.username);
		if (!error.username.valid) {
			errorMessage = errorMessage + " <strong>Kullanıcı Adı " + error.username.message + "</strong><br/>";
		}
		error.password = validateField(undefined, "1,45", data.password);
		if (!error.password.valid) {
			errorMessage = errorMessage + " <strong>Şifre " + error.password.message + "</strong><br/>";
		}
	}

	if(data.loginType === 'API' || type === AuthPageType.CICEKSEPETI){
		error.apiKey = validateField(undefined, type === AuthPageType.CICEKSEPETI ? "1,40" : "1,45", data.apiKey);
		if (!error.apiKey.valid) {
			errorMessage = errorMessage + " <strong>Api Key " + error.apiKey.message + "</strong><br/>";
		}

		if(data.loginType === 'API') {
			error.apiSecret = validateField(undefined, "1,45", data.apiSecret);
			if (!error.apiSecret.valid) {
				errorMessage = errorMessage + " <strong> Api Secret " + error.apiSecret.message + "</strong><br/>";
			}
		}
	}
	let valid = isValidObject(error);
	return {error: error, valid: (valid && !errorMessage), errorMessage: errorMessage};
}

export function isValidDvdAuth(data) {
	let error = {};
	let errorMessage = "";

	error.username = validateField(undefined, "1,45", data.username);
	if (!error.username.valid) {
		errorMessage = errorMessage + " <strong>Tc kimlik No/Vergi Kimlik No/Kullanıcı Kodu " + error.username.message + "</strong><br/>";
	}
	error.password = validateField(undefined, "1,45", data.password);
	if (!error.password.valid) {
		errorMessage = errorMessage + " <strong>Şifre " + error.password.message + "</strong><br/>";
	}
	error.captchaText = validateField(undefined, "5,5", data.captchaText);
	if (!error.captchaText.valid) {
		errorMessage = errorMessage + " <strong>Güvenlik kodu " + error.captchaText.message + "</strong><br/>";
	}
	let valid = isValidObject(error);
	return {error: error, valid: (valid && !errorMessage), errorMessage: errorMessage};
}

export function isValidUtsAuth(data) {
	let error = {};
	let errorMessage = "";
	error.token = validateField(undefined, "42,42", data.token);
	if (!error.token.valid) {
		errorMessage = errorMessage + " <strong>Token " + error.token.message + "</strong><br/>";
	}

	let valid = isValidObject(error);
	return {error: error, valid: (valid && !errorMessage), errorMessage: errorMessage};
}

export function isValidTurmobAuth(data) {
	let error = {};
	let errorMessage = "";
	error.token = validateField(undefined, "32,32", data.token);
	if (!error.token.valid) {
		errorMessage = errorMessage + " <strong>Token " + error.token.message + "</strong><br/>";
	}

	let valid = isValidObject(error);
	return {error: error, valid: (valid && !errorMessage), errorMessage: errorMessage};
}

export function isValidTurmobAuth2(data) {
	let error = {};
	let errorMessage = "";
	error.token = validateField(undefined, "32,32", data.token);
	if (!error.token.valid) {
		errorMessage = errorMessage + " <strong>Token " + error.token.message + "</strong><br/>";
	}

	let valid = isValidObject(error);
	return (valid && !errorMessage);
}

export function isValidLuca(data) {
	let error = {};
	let errorMessage = "";
	error.nettecapUser = validateField(undefined, "5,100", data.nettecapUser);
	if (!error.nettecapUser.valid) {
		errorMessage = errorMessage + " <strong>NetteCap Kullanıcı Adı " + error.nettecapUser.message + "</strong><br/>";
	}

	error.nettecapPwd = validateField(undefined, "5,100", data.nettecapPwd);
	if (!error.nettecapPwd.valid) {
		errorMessage = errorMessage + " <strong>NetteCap Şifresi " + error.nettecapPwd.message + "</strong><br/>";
	}

	error.nettecapMhn = validateField(undefined, "5,100", data.nettecapMhn);
	if (!error.nettecapMhn.valid) {
		errorMessage = errorMessage + " <strong>İşNet Müşteri Numarası " + error.nettecapMhn.message + "</strong><br/>";
	}

	error.lucaNumber = validateField(undefined, "5,100", data.lucaNumber);
	if (!error.lucaNumber.valid) {
		errorMessage = errorMessage + " <strong>Luca Üyelik Numarası " + error.lucaNumber.message + "</strong><br/>";
	}

	error.netteCapNumber = validateField(undefined, "5,100", data.netteCapNumber);
	if (!error.netteCapNumber.valid) {
		errorMessage = errorMessage + " <strong>Nettecap Üyelik Numarası " + error.netteCapNumber.message + "</strong><br/>";
	}

	let valid = isValidObject(error);
	return {error: error, valid: (valid && !errorMessage), errorMessage: errorMessage};
}


export function isValidNewExpenseNote(data, activeTab) {
	let error = {};
	let errorMessage = "";
	let tActiveTab = "";

	error.allowanceTotalAmount = validateField("decimal", undefined, data.allowanceTotalAmount);
	error.lineExtensionAmount = validateField("decimal", undefined, data.lineExtensionAmount);
	error.payableAmount = validateField("decimal", undefined, data.payableAmount);
	error.taxExclusiveAmount = validateField("decimal", undefined, data.taxExclusiveAmount);
	error.taxInclusiveAmount = validateField("decimal", undefined, data.taxInclusiveAmount);
	error.documentUuid = validateField("uuid", undefined, data.documentUuid);
	if (data.documentCurrencyCode !== "TRY") {
		error.paymentExchangeRate = validateField("decimal", undefined, data.paymentExchangeRate);
		if (!error.paymentExchangeRate.valid) {
			errorMessage = errorMessage + " <strong>Kur Değeri " + error.paymentExchangeRate.message + "</strong><br/>";
		}
	}

	let externalCustomer = data.externalCustomer;
	if (!data.retailCustomer) {
		let length = (isset(externalCustomer.vknTckn) ? externalCustomer.vknTckn.length : 11);
		if (length === 11) {
			error.givenName = validateField(undefined, "1,45", externalCustomer.givenName);
			if (!error.givenName.valid) {
				errorMessage = errorMessage + " <strong>Adı " + error.givenName.message + "</strong><br/>";
				tActiveTab = tActiveTab || "temelbilgiler";
			}
			error.familyName = validateField(undefined, "1,45", externalCustomer.familyName);
			if (!error.familyName.valid) {
				errorMessage = errorMessage + " <strong>Soyadı " + error.familyName.message + "</strong><br/>";
				tActiveTab = tActiveTab || "temelbilgiler";
			}
		} else {
			error.formattedName = validateField(undefined, "1,255", externalCustomer.formattedName);
			if (!error.formattedName.valid) {
				errorMessage = errorMessage + " <strong>Ünvan " + error.formattedName.message + "</strong><br/>";
				tActiveTab = tActiveTab || "temelbilgiler";
			}
		}
		error.taxOffice = validateField(undefined, "0,255", externalCustomer.taxOffice);
		if (!error.taxOffice.valid) {
			errorMessage = errorMessage + " <strong>Vergi dairesi " + error.taxOffice.message + "</strong><br/>";
			tActiveTab = tActiveTab || "temelbilgiler";
		}
		let externalCustomerAddress = data.externalCustomerAddress;
		error.cityName = validateField(undefined, "1,255", externalCustomerAddress.cityName);
		if (!error.cityName.valid) {
			errorMessage = errorMessage + " <strong>İl " + error.cityName.message + "</strong><br/>";
			tActiveTab = tActiveTab || "temelbilgiler";
		}

		error.citySubdivisionName = validateField(undefined, "1,255", externalCustomerAddress.citySubdivisionName);
		if (!error.citySubdivisionName.valid) {
			errorMessage = errorMessage + " <strong>İlçe " + error.citySubdivisionName.message + "</strong><br/>";
			tActiveTab = tActiveTab || "temelbilgiler";
		}

		error.countryName = validateField(undefined, "1,255", externalCustomerAddress.countryName);
		if (!error.countryName.valid) {
			errorMessage = errorMessage + " <strong>Ülke " + error.countryName.message + "</strong><br/>";
			tActiveTab = tActiveTab || "temelbilgiler";
		}

		error.email = validateField("email", "0,255", externalCustomerAddress.email);
		if (!error.email.valid) {
			errorMessage = errorMessage + " <strong> Alıcı e-Posta " + error.email.message + "</strong><br/>";
			tActiveTab = tActiveTab || "temelbilgiler";
		}
	} else {
		let docExternalCustomer = (data.trdDocExternalCustomer || {});
		error.email = validateField("email", "0,255", docExternalCustomer.email);
		if (!error.email.valid) {
			errorMessage = errorMessage + " <strong>E-Posta " + error.email.message + "</strong><br/>";
			tActiveTab = tActiveTab || "temelbilgiler";
		}

		let length = (isset(docExternalCustomer.vknTckn) ? docExternalCustomer.vknTckn.length : 11);
		if (length === 11) {
			error.givenName = validateField(undefined, "1,45", docExternalCustomer.givenName);
			if (!error.givenName.valid) {
				errorMessage = errorMessage + " <strong>Adı " + error.givenName.message + "</strong><br/>";
				tActiveTab = tActiveTab || "temelbilgiler";
			}
			error.familyName = validateField(undefined, "1,45", docExternalCustomer.familyName);
			if (!error.familyName.valid) {
				errorMessage = errorMessage + " <strong>Soyadı " + error.familyName.message + "</strong><br/>";
				tActiveTab = tActiveTab || "temelbilgiler";
			}
		} else {
			error.formattedName = validateField(undefined, "1,350", docExternalCustomer.formattedName);
			if (!error.formattedName.valid) {
				errorMessage = errorMessage + " <strong>Ünvan " + error.formattedName.message + "</strong><br/>";
				tActiveTab = tActiveTab || "temelbilgiler";
			}
		}

		error.cityName = validateField(undefined, "1,255", docExternalCustomer.cityName);
		if (!error.cityName.valid) {
			errorMessage = errorMessage + " <strong>İl " + error.cityName.message + "</strong><br/>";
			tActiveTab = tActiveTab || "temelbilgiler";
		}

		error.citySubdivisionName = validateField(undefined, "1,255", docExternalCustomer.citySubdivisionName);
		if (!error.citySubdivisionName.valid) {
			errorMessage = errorMessage + " <strong>İlçe " + error.citySubdivisionName.message + "</strong><br/>";
			tActiveTab = tActiveTab || "temelbilgiler";
		}

		error.countryName = validateField(undefined, "1,255", docExternalCustomer.countryName);
		if (!error.countryName.valid) {
			errorMessage = errorMessage + " <strong>Ülke " + error.countryName.message + "</strong><br/>";
			tActiveTab = tActiveTab || "temelbilgiler";
		}
	}


	let valid = isValidObject(error);
	return {
		error: error,
		valid: valid && !isset(errorMessage),
		activeTab: (tActiveTab || activeTab),
		errorMessage: errorMessage,
	};
}

export function isValidUtsData(data, type) {
	let error = {};
	let errorMessage = "";
	let isVermeBildirim = type === "vermeBildirimiGonder";

	// error.urunNo = validateField(undefined, isVermeBildirim ? "1,23" : "0,23", data.urunNo);
	// if (!error.urunNo.valid) {
	// 	errorMessage = errorMessage + " <strong>Ürün No " + error.urunNo.message + "</strong><br/>";
	// }
	//
	// error.lotBatchNumber = validateField(undefined, "0,20", data.lotBatchNumber);
	// if (!error.lotBatchNumber.valid) {
	// 	errorMessage = errorMessage + " <strong>Lot/Batch No " + error.lotBatchNumber.message + "</strong><br/>";
	// }
	//
	// error.serialNo = validateField(undefined, "0,20", data.serialNo);
	// if (!error.serialNo.valid) {
	// 	errorMessage = errorMessage + " <strong>Seri No " + error.serialNo.message + "</strong><br/>";
	// }
	//
	// error.quantity = validateField(undefined, "0,20", data.quantity);
	// if (!error.quantity.valid) {
	// 	errorMessage = errorMessage + " <strong>Adet " + error.quantity.message + "</strong><br/>";
	// }
	//
	// if (isVermeBildirim) {
	// 	error.kurumNo = validateField(undefined, "1,20", data.kurumNo);
	// 	if (!error.kurumNo.valid) {
	// 		errorMessage = errorMessage + " <strong>Kurum No " + error.kurumNo.message + "</strong><br/>";
	// 	}
	//
	// 	error.bedelsizNumune = validateField(undefined, "0,20", data.bedelsizNumune);
	// 	if (!error.bedelsizNumune.valid) {
	// 		errorMessage = errorMessage + " <strong>Bedelsiz Numune " + error.bedelsizNumune.message + "</strong><br/>";
	// 	}
	//
	// 	error.documentNumber = validateField(undefined, "1,20", data.documentNumber);
	// 	if (!error.documentNumber.valid) {
	// 		errorMessage = errorMessage + " <strong>Doküman Numarası " + error.documentNumber.message + "</strong><br/>";
	// 	}
	//
	// 	error.actualActionTime = validateField("date", "0,20", data.actualActionTime);
	// 	if (!error.actualActionTime.valid) {
	// 		errorMessage = errorMessage + " <strong>İşlem Zamanı " + error.actualActionTime.message + "</strong><br/>";
	// 	}
	// } else {
	// 	error.vermeBildirimId = validateField(undefined, "1,50", data.vermeBildirimId);
	// 	if (!error.vermeBildirimId.valid) {
	// 		errorMessage = errorMessage + " <strong>Verme Bildirim No " + error.vermeBildirimId.message + "</strong><br/>";
	// 	}
	//
	// 	error.uniqueDeviceIdentifier = validateField(undefined, "1,100", data.uniqueDeviceIdentifier);
	// 	if (!data.vermeBildirimId && !error.uniqueDeviceIdentifier.valid) {
	// 		errorMessage = errorMessage + " <strong>Eşsiz Kimlik No " + error.uniqueDeviceIdentifier.message + "</strong><br/>";
	// 	}
	//
	// 	error.gonderenKurumNumarasi = validateField("number", "1,50", data.gonderenKurumNumarasi);
	// 	if (!data.vermeBildirimId && !error.gonderenKurumNumarasi.valid) {
	// 		errorMessage = errorMessage + " <strong>Gönderen Kurum No " + error.gonderenKurumNumarasi.message + "</strong><br/>";
	// 	}
	// }

	let valid = isValidObject(error);
	return {error: error, valid: (valid && !errorMessage), errorMessage: errorMessage};
}

export function isValidInvoice(data, direction, isKamu, activeTab, innerActiveTab, isGocIdaresi, currentUser) {
	let error = {};
	let errorMessage = "";
	let tActiveTab = "";
	let tInnerActiveTab = "";
	let checkIstisnaKdv0 = false;

	let externalCustomer = data.externalCustomer;
	let trdDocExternalCustomer = data.trdDocExternalCustomer;
	let externalCustomerAddress = data.externalCustomerAddress;
	let tmpDocConnectorExCustomer = data.tmpDocConnectorExCustomer;

	let vknTckn,cityName,citySubdivisionName,countryName,email;
	let postboxAlias,givenName,familyName,formattedName,taxOffice;
	let buyerType;

	if(data.from==='CONNECTOR'){
		vknTckn = tmpDocConnectorExCustomer.vknTckn;
		cityName = tmpDocConnectorExCustomer.cityName;
		citySubdivisionName = tmpDocConnectorExCustomer.citySubdivisionName;
		countryName = tmpDocConnectorExCustomer.countryName;
		email = tmpDocConnectorExCustomer.email;
		givenName = tmpDocConnectorExCustomer.givenName;
		familyName = tmpDocConnectorExCustomer.familyName;
		formattedName = tmpDocConnectorExCustomer.formattedName;
		taxOffice = tmpDocConnectorExCustomer.taxOffice;
		postboxAlias = tmpDocConnectorExCustomer.postboxAlias;
		buyerType = tmpDocConnectorExCustomer.buyerType;
		error.vknTckn = validateField("identifier","10,11" ,vknTckn);
		if (!error.vknTckn.valid) {
			errorMessage = errorMessage + " <strong>Vkn/Tckn " + error.vknTckn.message + "</strong><br/>";
			tActiveTab = tActiveTab || "temelbilgiler";
		}
	}else{
		if(externalCustomer){
			vknTckn = externalCustomer.vknTckn
			cityName = externalCustomerAddress.cityName
			citySubdivisionName = externalCustomerAddress.citySubdivisionName
			countryName = externalCustomerAddress.countryName
			email = externalCustomerAddress.email
			givenName = externalCustomer.givenName
			familyName = externalCustomer.familyName
			formattedName = externalCustomer.formattedName
			taxOffice = externalCustomer.taxOffice
			postboxAlias = externalCustomerAddress.postboxAlias
			buyerType = externalCustomer.buyerType;
		}

		if(trdDocExternalCustomer){
			vknTckn = trdDocExternalCustomer.vknTckn
			cityName = trdDocExternalCustomer.cityName
			citySubdivisionName = trdDocExternalCustomer.citySubdivisionName
			countryName = trdDocExternalCustomer.countryName
			email = trdDocExternalCustomer.email
			givenName = trdDocExternalCustomer.givenName
			familyName = trdDocExternalCustomer.familyName
			formattedName = trdDocExternalCustomer.formattedName
			taxOffice = trdDocExternalCustomer.taxOffice
		}
	}

	error.allowanceTotalAmount = validateField("decimal", undefined, data.allowanceTotalAmount);
	error.lineExtensionAmount = validateField("decimal", undefined, data.lineExtensionAmount);
	error.payableAmount = validateField("decimal", undefined, data.payableAmount);
	error.taxExclusiveAmount = validateField("decimal", undefined, data.taxExclusiveAmount);
	error.taxInclusiveAmount = validateField("decimal", undefined, data.taxInclusiveAmount);
	error.documentUuid = validateField("uuid", undefined, data.documentUuid);
	if (data.documentCurrencyCode !== "TRY") {
		error.paymentExchangeRate = validateField("decimal", undefined, data.paymentExchangeRate);
		if (!error.paymentExchangeRate.valid) {
			errorMessage = errorMessage + " <strong>Kur Değeri " + error.paymentExchangeRate.message + "</strong><br/>";
		}
	}

	if (data.profileId === "HKS" || data.invoiceTypeCode === "HKSSATIS" || data.invoiceTypeCode === "HKSKOMISYONCU") {
		for (let i = 0; i < data.trdDocInvoiceLines.length; i++) {
			error.kunyeNo = validateField("kunyeNo", undefined, data.trdDocInvoiceLines[i].kunyeNo);
			if (!error.kunyeNo.valid) {
				errorMessage = errorMessage + " <strong> Künye Numarası 19 hane olmalıdır </strong><br/>";
				break;
			}
		}

		error.payableAmount = validateField("positive", undefined, data.payableAmount);
		if (!error.payableAmount.valid) {
			errorMessage = errorMessage + " <strong>Ödenecek Tutar " + error.payableAmount.message + " </strong><br/>"
		}

	}

	if (data.profileId !== "EARSIVFATURA" && data.profileId !== "IHRACAT" && data.profileId !== "YOLCUBERABERFATURA") {
		error['sourceUrn'] = validateField(undefined, "1,255", data.sourceUrn);
		if (!error.sourceUrn.valid) {
			errorMessage = errorMessage + " <strong>Gönderici Birim Etiketi " + error.sourceUrn.message + "</strong><br/>";
		}
	}

	if (data.profileId !== "EARSIVFATURA" && data.invoiceTypeCode === "IADE" && data.profileId !== "TEMELFATURA" && data.profileId !== "ILAC_TIBBICIHAZ") {
		errorMessage = errorMessage + " <strong>Fatura tipi IADE iken fatura profili sadece TEMELFATURA, ILAC_TIBBICIHAZ veya EARSIVFATURA olabilir</strong><br/>";
	}

	if(checkIade(data.invoiceTypeCode)){
		if (!data.trdDocInvoiceIadeLines || !data.trdDocInvoiceIadeLines.length > 0) {
			errorMessage += " <strong>En az 1 adet İadeye konu olan fatura bilgisi eklenmelidir.</strong><br/>";
		}
	}

	if (data.invoiceTypeCode === "TEVKIFATIADE") {
		let lines = data.trdDocInvoiceLines
		for (let i = 0; i < lines.length; i++) {
			let charger = lines[i].trdDocInvoiceLineCharges.filter(f => f.taxCode.code === '0015');
			if (charger[0]?.tevkifatsizKdvTutari === null || charger[0]?.tevkifatsizKdvTutari === "") {
				errorMessage = errorMessage + " <strong>Alıştaki Tevkifatsız KDV Tutarı boş olamaz!</strong><br/>";
			}
			if (charger[0]?.rateOfReturnedGood === null ||charger[0]?.rateOfReturnedGood === "") {
				errorMessage = errorMessage + " <strong>İade Edilen Mal Oranı boş olamaz!</strong><br/>";
			}
			if (charger[0]?.vatRefundAmount === null || charger[0]?.vatRefundAmount === "") {
				errorMessage = errorMessage + " <strong>İadeye Konu KDV Tutarı boş olamaz!</strong><br/>";
			}
		}
	}

	if (data.profileId !== "YOLCUBERABERFATURA") {
		let externalCustomer = data.externalCustomer;
		if (data.profileId === "IHRACAT") {
			if (buyerType === "OZEL") {
				error.givenName = validateField(undefined, "1,45", givenName);
				if (!error.givenName.valid) {
					errorMessage = errorMessage + " <strong>Adı " + error.givenName.message + "</strong><br/>";
					tActiveTab = tActiveTab || "temelbilgiler";
				}
				error.familyName = validateField(undefined, "1,45", familyName);
				if (!error.familyName.valid) {
					errorMessage = errorMessage + " <strong>Soyadı " + error.familyName.message + "</strong><br/>";
					tActiveTab = tActiveTab || "temelbilgiler";
				}
			} else {
				error.formattedName = validateField(undefined, "1,255", formattedName);
				if (!error.formattedName.valid) {
					errorMessage = errorMessage + " <strong>Resmi Ünvan " + error.formattedName.message + "</strong><br/>";
					tActiveTab = tActiveTab || "temelbilgiler";
				}
				if(data.from!=='CONNECTOR') {
					error.title = validateField(undefined, "1,255", externalCustomer.title);
					if (!error.title.valid) {
						errorMessage = errorMessage + " <strong>Firma Adı " + error.title.message + "</strong><br/>";
						tActiveTab = tActiveTab || "temelbilgiler";
					}
				}
			}
			error.buyerType = validateField(undefined, "1,45", buyerType);
			if (!error.buyerType.valid) {
				errorMessage = errorMessage + " <strong>Alıcı Türü " + error.buyerType.message + "</strong><br/>";
				tActiveTab = tActiveTab || "temelbilgiler";
			}

		} else {
			if (!data.retailCustomer && !data.isForeignCustomer) {
				let length = (isset(vknTckn) ? vknTckn.length : 11);
				if (length === 11) {
					error.givenName = validateField(undefined, "1,45", givenName);
					if (!error.givenName.valid) {
						errorMessage = errorMessage + " <strong>Adı " + error.givenName.message + "</strong><br/>";
						tActiveTab = tActiveTab || "temelbilgiler";
					}
					error.familyName = validateField(undefined, "1,45", familyName);
					if (!error.familyName.valid) {
						errorMessage = errorMessage + " <strong>Soyadı " + error.familyName.message + "</strong><br/>";
						tActiveTab = tActiveTab || "temelbilgiler";
					}
				} else {
					error.formattedName = validateField(undefined, "1,255", formattedName);
					if (!error.formattedName.valid) {
						errorMessage = errorMessage + " <strong>Ünvan " + error.formattedName.message + "</strong><br/>";
						tActiveTab = tActiveTab || "temelbilgiler";
					}
				}
				error.taxOffice = validateField(undefined, "0,255", taxOffice);
				if (!error.taxOffice.valid) {
					errorMessage = errorMessage + " <strong>Vergi dairesi " + error.taxOffice.message + "</strong><br/>";
					tActiveTab = tActiveTab || "temelbilgiler";
				}
			}

			if (data.isForeignCustomer) {
				let buyerType = externalCustomer.buyerType;
				if (buyerType === "OZEL") {
					error.givenName = validateField(undefined, "1,45", externalCustomer.givenName);
					if (!error.givenName.valid) {
						errorMessage = errorMessage + " <strong>Adı " + error.givenName.message + "</strong><br/>";
					}
					error.familyName = validateField(undefined, "1,45", externalCustomer.familyName);
					if (!error.familyName.valid) {
						errorMessage = errorMessage + " <strong>Soyadı " + error.familyName.message + "</strong><br/>";
					}
				} else {
					error.formattedName = validateField(undefined, "1,255", externalCustomer.formattedName);
					if (!error.formattedName.valid) {
						errorMessage = errorMessage + " <strong>Resmi Ünvan " + error.formattedName.message + "</strong><br/>";
					}
				}

				error.buyerType = validateField(undefined, "1,45", externalCustomer.buyerType);
				if (!error.buyerType.valid) {
					errorMessage = errorMessage + " <strong>Alıcı Türü " + error.buyerType.message + "</strong><br/>";
				}

				error.cityName = validateField(undefined, "1,255", externalCustomerAddress.cityName);
				if (!error.cityName.valid) {
					errorMessage = errorMessage + " <strong>İl " + error.cityName.message + "</strong><br/>";
				}

				error.citySubdivisionName = validateField(undefined, "1,255", externalCustomerAddress.citySubdivisionName);
				if (!error.citySubdivisionName.valid) {
					errorMessage = errorMessage + " <strong>İlçe " + error.citySubdivisionName.message + "</strong><br/>";
				}

				error.countryName = validateField(undefined, "1,255", externalCustomerAddress.countryName);
				if (!error.countryName.valid) {
					errorMessage = errorMessage + " <strong>Ülke " + error.countryName.message + "</strong><br/>";
				}
			}
		}

		if (!data.retailCustomer && !data.isForeignCustomer) {

			error.cityName = validateField(undefined, "1,255", cityName);
			if (!error.cityName.valid) {
				errorMessage = errorMessage + " <strong>İl " + error.cityName.message + "</strong><br/>";
				tActiveTab = tActiveTab || "temelbilgiler";
			}

			error.citySubdivisionName = validateField(undefined, "1,255", citySubdivisionName);
			if (!error.citySubdivisionName.valid) {
				errorMessage = errorMessage + " <strong>İlçe " + error.citySubdivisionName.message + "</strong><br/>";
				tActiveTab = tActiveTab || "temelbilgiler";
			}

			error.countryName = validateField(undefined, "1,255", countryName);
			if (!error.countryName.valid) {
				errorMessage = errorMessage + " <strong>Ülke " + error.countryName.message + "</strong><br/>";
				tActiveTab = tActiveTab || "temelbilgiler";
			}

			error.email = validateField("email", "0,255", email);
			if (!error.email.valid) {
				errorMessage = errorMessage + " <strong> Alıcı e-Posta " + error.email.message + "</strong><br/>";
				tActiveTab = tActiveTab || "temelbilgiler";
			}

			if (data.profileId !== "EARSIVFATURA" && data.profileId !== "IHRACAT" && direction === "Tmp" && EntegratorIdentifiers.BYM !== EntegratorConf.identifier) {
				error.postboxAlias = validateField("required", "1,255", postboxAlias);
				if (!error.postboxAlias.valid) {
					errorMessage = errorMessage + " <strong>Alıcı Posta Kutusu Etiketi " + error.postboxAlias.message + "</strong><br/>";
					tActiveTab = tActiveTab || "temelbilgiler";
				}
			}
		} else {
			if(!data.isForeignCustomer) {
				let docExternalCustomer = (data.trdDocExternalCustomer || {});
				error.email = validateField("email", "0,255", docExternalCustomer.email);
				if (!error.email.valid) {
					errorMessage = errorMessage + " <strong>E-Posta " + error.email.message + "</strong><br/>";
					tActiveTab = tActiveTab || "temelbilgiler";
				}

				let length = (isset(docExternalCustomer.vknTckn) ? docExternalCustomer.vknTckn.length : 11);
				error.vknTckn = validateField("identifier","10,11" ,docExternalCustomer.vknTckn);
				if (!error.vknTckn.valid) {
					errorMessage = errorMessage + " <strong>Vkn/Tckn " + error.vknTckn.message + "</strong><br/>";
					tActiveTab = tActiveTab || "temelbilgiler";
				}
				if (length === 11) {
					error.givenName = validateField(undefined, "1,45", docExternalCustomer.givenName);
					if (!error.givenName.valid) {
						errorMessage = errorMessage + " <strong>Adı " + error.givenName.message + "</strong><br/>";
						tActiveTab = tActiveTab || "temelbilgiler";
					}
					error.familyName = validateField(undefined, "1,45", docExternalCustomer.familyName);
					if (!error.familyName.valid) {
						errorMessage = errorMessage + " <strong>Soyadı " + error.familyName.message + "</strong><br/>";
						tActiveTab = tActiveTab || "temelbilgiler";
					}
				}else {
					error.formattedName = validateField(undefined, "2,350", docExternalCustomer.formattedName);
					if (!error.formattedName.valid) {
						errorMessage = errorMessage + " <strong>Ünvan " + error.formattedName.message + "</strong><br/>";
						tActiveTab = tActiveTab || "temelbilgiler";
					}
				}
				error.cityName = validateField(undefined, "1,255", docExternalCustomer.cityName);
				if (!error.cityName.valid) {
					errorMessage = errorMessage + " <strong>İl " + error.cityName.message + "</strong><br/>";
					tActiveTab = tActiveTab || "temelbilgiler";
				}

				error.citySubdivisionName = validateField(undefined, "1,255", docExternalCustomer.citySubdivisionName);
				if (!error.citySubdivisionName.valid) {
					errorMessage = errorMessage + " <strong>İlçe " + error.citySubdivisionName.message + "</strong><br/>";
					tActiveTab = tActiveTab || "temelbilgiler";
				}

				error.countryName = validateField(undefined, "1,255", docExternalCustomer.countryName);
				if (!error.countryName.valid) {
					errorMessage = errorMessage + " <strong>Ülke " + error.countryName.message + "</strong><br/>";
					tActiveTab = tActiveTab || "temelbilgiler";
				}
			}
		}
	} else {
		error.trpAlias = validateField("required", "1,255", data.trdDocInvoiceTaxFree ? data.trdDocInvoiceTaxFree.trpAlias : "");
		if (!error.trpAlias.valid) {
			errorMessage = errorMessage + " <strong>Posta Kutusu Etiketi" + error.trpAlias.message + "</strong><br/>";
			tActiveTab = tActiveTab || "digerbilgiler";
			tInnerActiveTab = "AraciKurumBilgileri";
		}
		error.trpIdentifier = validateField("identifier", "10,10", data.trdDocInvoiceTaxFree ? data.trdDocInvoiceTaxFree.trpIdentifier : "");
		if (!error.trpIdentifier.valid) {
			errorMessage = errorMessage + " <strong>VKN " + error.trpIdentifier.message + "</strong><br/>";
			tActiveTab = tActiveTab || "digerbilgiler";
			tInnerActiveTab = "AraciKurumBilgileri";
		}
		error.trpFormattedName = validateField(undefined, "1,255", data.trdDocInvoiceTaxFree ? data.trdDocInvoiceTaxFree.trpFormattedName : "");
		if (!error.trpFormattedName.valid) {
			errorMessage = errorMessage + " <strong>Ünvan " + error.trpFormattedName.message + "</strong><br/>";
			tActiveTab = tActiveTab || "digerbilgiler";
			tInnerActiveTab = "AraciKurumBilgileri";
		}
		error.trpCountry = validateField(undefined, "1,255", data.trdDocInvoiceTaxFree ? data.trdDocInvoiceTaxFree.trpCountry : "");
		if (!error.trpCountry.valid) {
			errorMessage = errorMessage + " <strong>Ülke " + error.trpCountry.message + "</strong><br/>";
			tActiveTab = tActiveTab || "digerbilgiler";
			tInnerActiveTab = "AraciKurumBilgileri";
		}
		error.trpCity = validateField(undefined, "1,255", data.trdDocInvoiceTaxFree ? data.trdDocInvoiceTaxFree.trpCity : "");
		if (!error.trpCity.valid) {
			errorMessage = errorMessage + " <strong>Şehir " + error.trpCity.message + "</strong><br/>";
			tActiveTab = tActiveTab || "digerbilgiler";
			tInnerActiveTab = "AraciKurumBilgileri";
		}
		error.trpCitySubdivision = validateField(undefined, "1,255", data.trdDocInvoiceTaxFree ? data.trdDocInvoiceTaxFree.trpCitySubdivision : "");
		if (!error.trpCitySubdivision.valid) {
			errorMessage = errorMessage + " <strong>İlçe " + error.trpCitySubdivision.message + "</strong><br/>";
			tActiveTab = tActiveTab || "digerbilgiler";
			tInnerActiveTab = "AraciKurumBilgileri";
		}
		error.tFirstName = validateField(undefined, "1,255", data.trdDocInvoiceTaxFree ? data.trdDocInvoiceTaxFree.firstName : "");
		if (!error.tFirstName.valid) {
			errorMessage = errorMessage + " <strong>Turist Adı " + error.tFirstName.message + "</strong><br/>";
			tActiveTab = tActiveTab || "digerbilgiler";
			tInnerActiveTab = "AraciKurumBilgileri";
		}
		error.tFamilyName = validateField(undefined, "1,255", data.trdDocInvoiceTaxFree ? data.trdDocInvoiceTaxFree.familyName : "");
		if (!error.tFamilyName.valid) {
			errorMessage = errorMessage + " <strong>Turist Soyadı " + error.tFamilyName.message + "</strong><br/>";
			tActiveTab = tActiveTab || "digerbilgiler";
			tInnerActiveTab = "AraciKurumBilgileri";
		}
		error.touristCity = validateField(undefined, "1,255", data.trdDocInvoiceTaxFree ? data.trdDocInvoiceTaxFree.touristCity : "");
		if (!error.touristCity.valid) {
			errorMessage = errorMessage + " <strong>Turist İl bilgisi " + error.touristCity.message + "</strong><br/>";
			tActiveTab = tActiveTab || "temelbilgiler";
		}
		error.touristCitySubdivision = validateField(undefined, "1,255", data.trdDocInvoiceTaxFree ? data.trdDocInvoiceTaxFree.touristCitySubdivision : "");
		if (!error.touristCitySubdivision.valid) {
			errorMessage = errorMessage + " <strong>Turist İlçe bilgesi " + error.touristCitySubdivision.message + "</strong><br/>";
			tActiveTab = tActiveTab || "temelbilgiler";
		}
		error.touristCountry = validateField(undefined, "1,255", data.trdDocInvoiceTaxFree ? data.trdDocInvoiceTaxFree.touristCountry : "");
		if (!error.touristCountry.valid) {
			errorMessage = errorMessage + " <strong>Turist Ülke bilgisi" + error.touristCountry.message + "</strong><br/>";
			tActiveTab = tActiveTab || "temelbilgiler";
		}
		error.touristNationality = validateField(undefined, "1,255", data.trdDocInvoiceTaxFree ? data.trdDocInvoiceTaxFree.touristNationality : "");
		if (!error.touristNationality.valid) {
			errorMessage = errorMessage + " <strong>Turist Ulus bilgisi" + error.touristNationality.message + "</strong><br/>";
			tActiveTab = tActiveTab || "temelbilgiler";
		}
		error.touristPassportDate = validateField("dateDB", "1,255", data.trdDocInvoiceTaxFree ? data.trdDocInvoiceTaxFree.touristPassportDate : "");
		if (!error.touristPassportDate.valid) {
			errorMessage = errorMessage + " <strong>Turist Pasaport Tarihi Bilgisi" + error.touristPassportDate.message + "</strong><br/>";
			tActiveTab = tActiveTab || "temelbilgiler";
		}
		error.touristPassportNo = validateField(undefined, "1,255", data.trdDocInvoiceTaxFree ? data.trdDocInvoiceTaxFree.touristPassportNo : "");
		if (!error.touristPassportNo.valid) {
			errorMessage = errorMessage + " <strong>Turist Pasaport No Bilgisi" + error.touristPassportNo.message + "</strong><br/>";
			tActiveTab = tActiveTab || "temelbilgiler";
		}
	}


	if (data.invoiceTypeCode === "SARJ" || data.invoiceTypeCode === "SARJANLIK") {
		error.periodStartDateTime = validateField("datetime", "1,20", moment(data.periodStartDateTime).format("DD-MM-YYYY HH:mm:ss"));
		if (!error.periodStartDateTime.valid) {
			errorMessage = errorMessage + " <strong> Şarj Başlangıç Tarihi " + error.periodStartDateTime.message + " </strong> <br/> ";

		}
		error.periodEndDateTime = validateField("datetime", "1,20", moment(data.periodEndDateTime).format("DD-MM-YYYY HH:mm:ss"));
		if (!error.periodEndDateTime.valid) {
			errorMessage = errorMessage + " <strong> Şarj Bitiş Tarihi " + error.periodEndDateTime.message + " </strong> <br/> ";

		}
		error.plakaNo = validateField(undefined, "1,255", data.plakaNo);
		if (!error.plakaNo.valid) {
			errorMessage = errorMessage + " <strong>Ek bilgiler->Plaka No " + error.plakaNo.message + "</strong><br/>";
			tActiveTab = tActiveTab || "digerbilgiler";
			tInnerActiveTab = "EkBilgiler";
		}

		if (moment(data.periodStartDateTime).isAfter(moment(data.periodEndDateTime))) {
			errorMessage = errorMessage + " <strong> Şarj Başlangıç Tarihi, Şarj Bitiş Tarihi'nden sonra olamaz </strong> <br/>";
		}

		if (data.trdDocInvoiceLines.length !== 1) {
			errorMessage = errorMessage + "<strong>" + data.invoiceTypeCode + " Fatura Türünde sadece bir satır olmalıdır </strong><br/>";
		} else if (data.trdDocInvoiceLines[0].unit !== "KWH") {
			errorMessage = errorMessage + "<strong>" + data.invoiceTypeCode + " Fatura Türünde Birim Türü KWH olmalıdır </strong><br/>";
		}
	}

	if(data.invoiceTypeCode === "SARJ") {
		if (!data.esuRaporId) {
			errorMessage = errorMessage + " <strong>Diğer Bilgiler->Ek bilgiler->ESU Rapor ID bilgisi şarj ve şarj anlık fatura türlerinde girilmelidir.</strong><br/>";
			tActiveTab = tActiveTab || "digerbilgiler";
			tInnerActiveTab = "EkBilgiler";
		}
		if (!data.esuRaporIdIssueDate) {
			errorMessage = errorMessage + " <strong>Diğer Bilgiler->Ek bilgiler->ESU Rapor ID Oluşturulma Zamanı bilgisi şarj ve şarj anlık fatura türlerinde girilmelidir.</strong><br/>";
			tActiveTab = tActiveTab || "digerbilgiler";
			tInnerActiveTab = "EkBilgiler";
		}
	}

	if (data.profileId === "EARSIVFATURA") {
		error['sendingType'] = validateField(undefined, "1,10", data.sendingType);
		if (!error.sendingType.valid) {
			errorMessage = errorMessage + " <strong>Gönderim Şekli " + error.sendingType.message + "</strong><br/>";
		}
		let internetSales = data.trdDocInvoiceInternetSales;
		if (internetSales) {
			error.actualDeliveryDate = validateField("dateDB", "1,255", data.actualDeliveryDate);
			if (!error.actualDeliveryDate.valid) {
				errorMessage = errorMessage + " <strong>Gönderim Tarihi " + error.actualDeliveryDate.message + "</strong><br/>";
				tActiveTab = tActiveTab || "digerbilgiler";
				tInnerActiveTab = "TasiyiciBilgileri";
			}
			error.carrierPartyId = validateField("identifier", "10,11", data.carrierPartyId);
			if (!error.carrierPartyId.valid) {
				errorMessage = errorMessage + " <strong>Taşıyıcı VKN/TCKN " + error.carrierPartyId.message + "</strong><br/>";
				tActiveTab = tActiveTab || "digerbilgiler";
				tInnerActiveTab = "TasiyiciBilgileri";
			}
			if (data.carrierPartyId && data.carrierPartyId.length === 10) {
				error.carrierPartyName = validateField(undefined, "1,255", data.carrierPartyName);
				if (!error.carrierPartyName.valid) {
					errorMessage = errorMessage + " <strong>Taşıyıcı Ünvan " + error.carrierPartyName.message + "</strong><br/>";
					tActiveTab = tActiveTab || "digerbilgiler";
					tInnerActiveTab = "TasiyiciBilgileri";
				}
			}
			if (data.carrierPartyId && data.carrierPartyId.length === 11) {
				error.carrierPartyFirstName = validateField(undefined, "1,255", data.carrierPartyFirstName);
				if (!error.carrierPartyFirstName.valid) {
					errorMessage = errorMessage + " <strong>Taşıyıcı Adı " + error.carrierPartyFirstName.message + "</strong><br/>";
					tActiveTab = tActiveTab || "digerbilgiler";
					tInnerActiveTab = "TasiyiciBilgileri";
				}
				error.carrierPartyFamilyName = validateField(undefined, "1,255", data.carrierPartyFamilyName);
				if (!error.carrierPartyFamilyName.valid) {
					errorMessage = errorMessage + " <strong>Taşıyıcı Soyadı " + error.carrierPartyFamilyName.message + "</strong><br/>";
					tActiveTab = tActiveTab || "digerbilgiler";
					tInnerActiveTab = "TasiyiciBilgileri";
				}
			}
		}
	}

	if (direction === "Tmp") {
		error.xsltPath = validateField(undefined, "1,255", data.xsltPath);
		if (!error.xsltPath.valid) {
			errorMessage = errorMessage + " <strong>XSLT Dosyası " + error.xsltPath.message + "</strong><br/>";
		}
	}

	let references = data.trdDocInvoiceDespatchReferences;
	for (let i = 0; i < references.length; i++) {
		let reference = references[i];
		if (reference.referenceIssueDate || reference.referenceId) {
			error['referenceId_' + i] = validateField(undefined, "1,255", reference.referenceId);
			if (!error['referenceId_' + i].valid) {
				errorMessage = errorMessage + " <strong>" + (i + 1) + ". İrsaliye No " + error['referenceId_' + i].message + "</strong><br/>";
				tActiveTab = tActiveTab || "digerbilgiler";
				tInnerActiveTab = "IrsaliyeBilgileri";
			}
			error['referenceIssueDate_' + i] = validateField("date", "1,255", reference.referenceIssueDate);
			if (!error['referenceIssueDate_' + i].valid) {
				errorMessage = errorMessage + " <strong>" + (i + 1) + ". İrsaliye Tarihi " + error['referenceIssueDate_' + i].message + "</strong><br/>";
				tActiveTab = tActiveTab || "digerbilgiler";
				tInnerActiveTab = "IrsaliyeBilgileri";
			}
		}
	}

	if (data.orderReferenceNumber || data.orderReferenceDate) {
		error["orderReferenceNumber"] = validateField(undefined, "1,20", data.orderReferenceNumber);
		if (!error['orderReferenceNumber'].valid) {
			errorMessage = errorMessage + " <strong>Sipariş No " + error.orderReferenceNumber.message + "</strong><br/>";
			tActiveTab = tActiveTab || "digerbilgiler";
			tInnerActiveTab = "SiparisBilgileri";
		}
		error["orderReferenceDate"] = validateField("dateDB", "1,255", data.orderReferenceDate);
		if (!error['orderReferenceDate'].valid) {
			errorMessage = errorMessage + " <strong>Sipariş Tarihi " + error.orderReferenceDate.message + "</strong><br/>";
			tActiveTab = tActiveTab || "digerbilgiler";
			tInnerActiveTab = "SiparisBilgileri";
		}
	}

	let internetSales = data.trdDocInvoiceInternetSales;
	if (internetSales && data.profileId === "EARSIVFATURA") {
		error["SdocumentType"] = validateField(undefined, "1,255", internetSales.documentType);
		if (!error['SdocumentType'].valid) {
			errorMessage = errorMessage + " <strong>Ödeme Şekli " + error["SdocumentType"].message + "</strong><br/>";
			tActiveTab = tActiveTab || "digerbilgiler";
			tInnerActiveTab = "InternetSatisBilgileri";
		}
		error["SwebSite"] = validateField("url", "1,255", internetSales.webSite);
		if (!error['SwebSite'].valid) {
			errorMessage = errorMessage + " <strong>Satış Web Sitesi " + error["SwebSite"].message + "</strong><br/>";
			tActiveTab = tActiveTab || "digerbilgiler";
			tInnerActiveTab = "InternetSatisBilgileri";
		}
		if (internetSales.documentType === "DIGER") {
			error["Sdescription"] = validateField(undefined, "1,255", internetSales.description);
			if (!error['Sdescription'].valid) {
				errorMessage = errorMessage + " <strong>Ödeme Detayı " + error["Sdescription"].message + "</strong><br/>";
				tActiveTab = tActiveTab || "digerbilgiler";
				tInnerActiveTab = "InternetSatisBilgileri";
			}
		}
		error["SissueDate"] = validateField("dateDB", "1,255", internetSales.issueDate);
		if (!error['SissueDate'].valid) {
			errorMessage = errorMessage + " <strong>Ödeme Tarihi " + error["SissueDate"].message + "</strong><br/>";
			tActiveTab = tActiveTab || "digerbilgiler";
			tInnerActiveTab = "InternetSatisBilgileri";
		}
	}

	let trdDocInvoiceLines = data.trdDocInvoiceLines;
	let has9015 = false;
	let checkInvoiceType = true;
	for (let i = 0; i < trdDocInvoiceLines.length; i++) {
		let trdDocInvoiceLine = trdDocInvoiceLines[i];
		error['itemName_' + i] = validateField(undefined, "1,255", trdDocInvoiceLine.itemName);
		if (!error['itemName_' + i].valid) {
			errorMessage = errorMessage + " <strong>" + (i + 1) + ". satırdaki Ürün/Hizmet " + error['itemName_' + i].message + "</strong><br/>";
		}
		if (new Decimal(trdDocInvoiceLine.quantity).eq(0.00)) {
			errorMessage = errorMessage + (i + 1) + " .<strong> satırdaki miktar 0 olamaz.<br/></strong>";
		}
		if (data.profileId === "IHRACAT" || data.profileId === "YOLCUBERABERFATURA") {
			error['gumrukTakipNo_' + i] = validateField(undefined, "0,255", trdDocInvoiceLine.gumrukTakipNo);
			if (!error['gumrukTakipNo_' + i].valid) {
				errorMessage = errorMessage + " <strong>" + (i + 1) + ". satırdaki Gümrük Takip No " + error['gumrukTakipNo_' + i].message + "</strong><br/>";
			}
		}

		if (data.profileId === "IHRACAT") {
			if (!trdDocInvoiceLine.trdDocInvoiceLineDeliveryDetail) {
				errorMessage = errorMessage + " " + (i + 1) + ". <strong>satırdaki teslimat bilgilerini doldurunuz.</strong><br/>";
			} else {
				let deliveryDetail = trdDocInvoiceLine.trdDocInvoiceLineDeliveryDetail;
				let result = isValidDeliveryDetail(deliveryDetail);
				if (!result.valid) {
					errorMessage = errorMessage + " " + (i + 1) + ". <strong>satırdaki İşlemler->Teslimat Bilgilerini kontrol ediniz.</strong><br/>";
				}
			}
		}

		if (data.invoiceTypeCode === "ISTISNA") {
			if (trdDocInvoiceLine.trdDocInvoiceLineDeliveryDetail && trdDocInvoiceLine.trdDocInvoiceLineDeliveryDetail.gtip) {
				error.gtip = validateField("gtip", "12,12", trdDocInvoiceLine.trdDocInvoiceLineDeliveryDetail.gtip);

				if(!error.gtip.valid) {
					errorMessage = errorMessage + +(i + 1) + " . <strong> Satır gtip numarası " + error.gtip.message + "<br/></strong>";
				}
			}
		}

		if (isKamu) {
			let result = isValidMgmDetail(trdDocInvoiceLine.originCountryCode, trdDocInvoiceLine.classificationType, trdDocInvoiceLine.classificationValue);
			if (!result.valid) {
				errorMessage = errorMessage + " " + (i + 1) + ". <strong>satırdaki İşlemler->MGM Ek Bilgilerini kontrol ediniz.</strong><br/>";
			}
		}

		let charges = trdDocInvoiceLine.trdDocInvoiceLineCharges;
		for (let j = 0; j < charges.length; j++) {
			if (charges[j].taxCode.code === "9015") {
				if ((data.invoiceTypeCode !== "TEVKIFAT" && data.invoiceTypeCode !== "SGK" && data.invoiceTypeCode !== "IADE")) {
					errorMessage = errorMessage + +(i + 1) + " . <strong>KDV Tevkifatı ekli iken fatura türü TEVKİFAT, SGK ya da İADE olmalıdır.<br/></strong>";
				} else {
					has9015 = true;
				}
			}

			let gocCheck = false;
			for (let count = 0; count < data.trdDocInvoiceNotes.length; count++) {
				if(data.trdDocInvoiceNotes[count].note === "FATURATIPI:SGK") {
					gocCheck = true;
				}
			}

			if (charges[j].taxCode.code === "0015") {
				let percantage = new Decimal(charges[j].percentage);
				if (currentUser === null || currentUser === undefined || currentUser.checkKdv === null || currentUser.checkKdv) {
					if (!(percantage.eq(new Decimal(0)) ||
						percantage.eq(new Decimal(1)) ||
						percantage.eq(new Decimal(8)) ||
						percantage.eq(new Decimal(10)) ||
						percantage.eq(new Decimal(18)) ||
						percantage.eq(new Decimal(20)))) {
						errorMessage = errorMessage + (i + 1) + " .<strong> Satır KDV Değeri 0, 1, 8, 10, 18, 20 değerlerinden biri olmalıdır.<br/></strong>";
					}
				}

				if ((percantage.eq(new Decimal(0)) || (new Decimal(charges[j].amount)).equals(new Decimal(0)))) {
					if (data.profileId !== "IHRACAT" &&
						!charges[j].exemptionReasonCode &&
						data.invoiceTypeCode !== "SGK" &&
						data.invoiceTypeCode !== "KONAKLAMAVERGISI" &&
						!isGocIdaresi && !gocCheck) {
						errorMessage = errorMessage + (i + 1) + " .<strong> Satır KDV Değeri Sıfır iken KDV istisna sebebi boş bırakılamaz.<br/></strong>";
					}
					if (data.invoiceTypeCode !== "IADE" &&
						data.invoiceTypeCode !== "ISTISNA" &&
						data.invoiceTypeCode !== "KONAKLAMAVERGISI" &&
						data.invoiceTypeCode !== "TEVKIFAT" &&
						data.invoiceTypeCode !== "IHRACKAYITLI" &&
						data.invoiceTypeCode !== "SGK" &&
						data.invoiceTypeCode !== "OZELMATRAH" &&
						!isGocIdaresi &&
						!(charges[j].exemptionReasonCode === 351 ||
							charges[j].exemptionReasonCode === "351")) {
						checkInvoiceType = false;
					}
					for (let count = 0; count < data.trdDocInvoiceNotes.length; count++) {
						if(data.trdDocInvoiceNotes[count].note === "FATURATIPI:SGK") {
							checkInvoiceType = true;
						}
					}
				}
			}
		}

		if (data.invoiceTypeCode === "SARJANLIK") {
			error['chargeUnitSerialNumber_' + i] = validateField(undefined, "1,255", trdDocInvoiceLine.chargeUnitSerialNumber);
			if (!error['chargeUnitSerialNumber_' + i].valid) {
				errorMessage = errorMessage + " <strong>" + (i + 1) + ". satırdaki Şarj Ünitesi Seri No " + error['chargeUnitSerialNumber_' + i].message + "</strong><br/>";
			}
		}
	}

	if (!checkInvoiceType) {
		errorMessage = errorMessage + " <strong>KDV Değeri Sıfır olan satır içeren faturaların senaryo türü IADE, ISTISNA,IHRACKAYITLI yada OZELMATRAH olmalıdır.</strong>";
	}

	if (data.invoiceTypeCode === "TEVKIFAT") {
		if (!has9015)
			errorMessage = errorMessage + " <strong>Fatura türü TEVKİFAT iken en az bir satıra 9015-KDV TEVKİFAT vergisi eklenmelidir.</strong>";
	}

	if (data.profileId === "IHRACAT") {
		error['paymentMeansCode'] = validateField(undefined, "1,255", data.paymentMeansCode);
		if (!error['paymentMeansCode'].valid) {
			errorMessage = errorMessage + " <strong>Ödeme Şekli " + error.paymentMeansCode.message + "</strong><br/>";
			tActiveTab = tActiveTab || "digerbilgiler";
			tInnerActiveTab = "OdemeBilgileri";
		}
		error['paymentChannelCode'] = validateField(undefined, "1,255", data.paymentChannelCode);
		if (!error['paymentChannelCode'].valid) {
			errorMessage = errorMessage + " <strong>Ödeme Kanalı " + error.paymentChannelCode.message + "</strong><br/>";
			tActiveTab = tActiveTab || "digerbilgiler";
			tInnerActiveTab = "OdemeBilgileri";
		}
		error['paymentFinancialAccountId'] = validateField('iban', "1,255", data.paymentFinancialAccountId);
		if (!error['paymentFinancialAccountId'].valid) {
			errorMessage = errorMessage + " <strong>Hesap Numarası " + error.paymentFinancialAccountId.message + "</strong><br/>";
			tActiveTab = tActiveTab || "digerbilgiler";
			tInnerActiveTab = "OdemeBilgileri";
		}
	}

	if (isKamu) {
		error['paymentMeansCode'] = validateField(undefined, "1,255", data.paymentMeansCode);
		if (!error['paymentMeansCode'].valid) {
			errorMessage = errorMessage + " <strong>Kamuya kesilen faturalarda Ödeme Şekli " + error.paymentMeansCode.message + "</strong><br/>";
			tActiveTab = tActiveTab || "digerbilgiler";
			tInnerActiveTab = "OdemeBilgileri";
		}
		error['paymentChannelCode'] = validateField(undefined, "0,255", data.paymentChannelCode);
		if (!error['paymentChannelCode'].valid) {
			errorMessage = errorMessage + " <strong>Kamuya kesilen faturalarda  Ödeme Kanalı " + error.paymentChannelCode.message + "</strong><br/>";
			tActiveTab = tActiveTab || "digerbilgiler";
			tInnerActiveTab = "OdemeBilgileri";
		}
		error['paymentFinancialAccountId'] = validateField('iban', "1,255", data.paymentFinancialAccountId);
		if (!error['paymentFinancialAccountId'].valid) {
			errorMessage = errorMessage + " <strong>Kamuya kesilen faturalarda  Hesap Numarası " + error.paymentFinancialAccountId.message + "</strong><br/>";
			tActiveTab = tActiveTab || "digerbilgiler";
			tInnerActiveTab = "OdemeBilgileri";
		}
		error['paymentFormattedName'] = validateField(undefined, "1,350", data.paymentFormattedName);
		if (!error['paymentFormattedName'].valid) {
			errorMessage = errorMessage + " <strong>Kamuya kesilen faturalarda ödeme Yapacak Alıcı Ünvanı " + error.paymentFormattedName.message + "</strong><br/>";
			tActiveTab = tActiveTab || "digerbilgiler";
			tInnerActiveTab = "OdemeBilgileri";
		}
		error['paymentVkn'] = validateField(undefined, "1,10", data.paymentVkn);
		if (!error['paymentVkn'].valid) {
			errorMessage = errorMessage + " <strong>Kamuya kesilen faturalarda ödeme yapacak Alıcı VKN " + error.paymentVkn.message + "</strong><br/>";
			tActiveTab = tActiveTab || "digerbilgiler";
			tInnerActiveTab = "OdemeBilgileri";
		}
		error['paymentCity'] = validateField(undefined, "1,255", data.paymentCity);
		if (!error['paymentCity'].valid) {
			errorMessage = errorMessage + " <strong>Kamuya kesilen faturalarda ödeme yapacak Alıcı İli " + error.paymentCity.message + "</strong><br/>";
			tActiveTab = tActiveTab || "digerbilgiler";
			tInnerActiveTab = "OdemeBilgileri";
		}
		error['paymentCountry'] = validateField(undefined, "1,255", data.paymentCountry);
		if (!error['paymentCountry'].valid) {
			errorMessage = errorMessage + " <strong>Kamuya kesilen faturalarda ödeme yapacak Alıcı Ülkesi " + error.paymentCountry.message + "</strong><br/>";
			tActiveTab = tActiveTab || "digerbilgiler";
			tInnerActiveTab = "OdemeBilgileri";
		}
	}



	if (data.invoiceTypeCode === "SGK") {
		error['accountingCost'] = validateField(undefined, "1,255", data.accountingCost);
		if (data.accountingCost === "ABONELIK" || data.accountingCost === "MAL_HIZMET") {
			error['sgkFileNo'] = validateField(undefined, "1,255", data.sgkFileNo);
			if (!error['sgkFileNo'].valid) {
				errorMessage = errorMessage + " <strong>SGK Dosya No " + error.sgkFileNo.message + "</strong><br/>";
				tActiveTab = tActiveTab || "digerbilgiler";
				tInnerActiveTab = "SGKBilgileri";
			}
			error['paymentMeansCode'] = validateField(undefined, "1,255", data.paymentMeansCode);
			if (!error['paymentMeansCode'].valid) {
				errorMessage = errorMessage + " <strong>Ödeme Şekli " + error.paymentMeansCode.message + "</strong><br/>";
				tActiveTab = tActiveTab || "digerbilgiler";
				tInnerActiveTab = "OdemeBilgileri";
			}
			error['paymentFinancialAccountId'] = validateField('iban', "1,255", data.paymentFinancialAccountId);
			if (!error['paymentFinancialAccountId'].valid) {
				errorMessage = errorMessage + " <strong>Hesap Numarası " + error.paymentFinancialAccountId.message + "</strong><br/>";
				tActiveTab = tActiveTab || "digerbilgiler";
				tInnerActiveTab = "OdemeBilgileri";
			}

		} else {
			if (data.accountingCost !== "DIGER") {
				error['periodStartDate'] = validateField(undefined, "1,255", data.periodStartDate);
				if (!error['periodStartDate'].valid) {
					errorMessage = errorMessage + " <strong>Fatura Bilgileri->Dönem Bilgisi boş bırakılamaz</strong><br/>";
					tActiveTab = "temelbilgiler";
				}
				error['sgkMukellefKodu'] = validateField(undefined, "1,255", data.sgkMukellefKodu);
				if (!error['sgkMukellefKodu'].valid) {
					errorMessage = errorMessage + " <strong>SGK Mükellef Kodu " + error.sgkMukellefKodu.message + "</strong><br/>";
					tActiveTab = tActiveTab || "digerbilgiler";
					tInnerActiveTab = "SGKBilgileri";
				}
				error['sgkMukellefAdi'] = validateField(undefined, "1,255", data.sgkMukellefAdi);
				if (!error['sgkMukellefAdi'].valid) {
					errorMessage = errorMessage + " <strong>SGK Mükellef Adı " + error.sgkMukellefAdi.message + "</strong><br/>";
					tActiveTab = tActiveTab || "digerbilgiler";
					tInnerActiveTab = "SGKBilgileri";
				}
				error['sgkFileNo'] = validateField(undefined, "1,255", data.sgkFileNo);
				if (!error['sgkFileNo'].valid) {
					errorMessage = errorMessage + " <strong>SGK Dosya No " + error.sgkFileNo.message + "</strong><br/>";
					tActiveTab = tActiveTab || "digerbilgiler";
					tInnerActiveTab = "SGKBilgileri";
				}
			}

		}
	}

	if (currentUser !== null &&
		data.invoiceTypeCode === 'ISTISNA' &&
		data.profileId !== 'IHRACAT' &&
		data.profileId !== 'YOLCUBERABERFATURA') {
		data.trdDocInvoiceLines.map((line) =>
			line.trdDocInvoiceLineCharges.filter((charge) => {
					if (charge.taxCode.code === '0015') {
						if(charge.percentage === 0){
							checkIstisnaKdv0 = true;
						}
					}
				}
			)
		);
		if(!checkIstisnaKdv0){
			errorMessage = errorMessage + " <strong>Fatura Türü ISTISNA iken en az bir adet kdv 0 olan kalem olmalıdır. </strong><br/>";
		}
	}

	let valid = isValidObject(error);
	return {
		error: error,
		valid: valid && !isset(errorMessage),
		errorMessage: errorMessage,
		activeTab: (tActiveTab || activeTab),
		innerActiveTab: (tInnerActiveTab || innerActiveTab)
	};
}

export function isValidBelge(data, direction, isKamu, activeTab, innerActiveTab, isGocIdaresi) {
	let error = {};
	let errorMessage = "";
	let tActiveTab = "";
	let tInnerActiveTab = "";
	error.allowanceTotalAmount = validateField("decimal", undefined, data.allowanceTotalAmount);
	error.lineExtensionAmount = validateField("decimal", undefined, data.lineExtensionAmount);
	error.payableAmount = validateField("decimal", undefined, data.payableAmount);
	error.taxExclusiveAmount = validateField("decimal", undefined, data.taxExclusiveAmount);
	error.taxInclusiveAmount = validateField("decimal", undefined, data.taxInclusiveAmount);
	error.documentUuid = validateField("uuid", undefined, data.documentUuid);
	if (data.documentCurrencyCode !== "TRY") {
		error.paymentExchangeRate = validateField("decimal", undefined, data.paymentExchangeRate);
		if (!error.paymentExchangeRate.valid) {
			errorMessage = errorMessage + " <strong>Kur Değeri " + error.paymentExchangeRate.message + "</strong><br/>";
		}
	}

	let externalCustomer = data.externalCustomer;
	if (!data.retailCustomer) {
		let length = (isset(externalCustomer.vknTckn) ? externalCustomer.vknTckn.length : 11);
		if (length === 11) {
			error.givenName = validateField(undefined, "1,45", externalCustomer.givenName);
			if (!error.givenName.valid) {
				errorMessage = errorMessage + " <strong>Adı " + error.givenName.message + "</strong><br/>";
				tActiveTab = tActiveTab || "temelbilgiler";
			}
			error.familyName = validateField(undefined, "1,45", externalCustomer.familyName);
			if (!error.familyName.valid) {
				errorMessage = errorMessage + " <strong>Soyadı " + error.familyName.message + "</strong><br/>";
				tActiveTab = tActiveTab || "temelbilgiler";
			}
		} else {
			error.formattedName = validateField(undefined, "1,100", externalCustomer.formattedName);
			if (!error.formattedName.valid) {
				errorMessage = errorMessage + " <strong>Ünvan " + error.formattedName.message + "</strong><br/>";
				tActiveTab = tActiveTab || "temelbilgiler";
			}

			if ("2222222222" !== externalCustomer.vknTckn) {
				error.taxOffice = validateField(undefined, "1,255", externalCustomer.taxOffice);
				if (!error.taxOffice.valid) {
					errorMessage = errorMessage + " <strong>Vergi dairesi " + error.taxOffice.message + "</strong><br/>";
					tActiveTab = tActiveTab || "temelbilgiler";
				}
			}
		}

		let externalCustomerAddress = data.externalCustomerAddress;
		error.cityName = validateField(undefined, "1,255", externalCustomerAddress.cityName);
		if (!error.cityName.valid) {
			errorMessage = errorMessage + " <strong>İl " + error.cityName.message + "</strong><br/>";
			tActiveTab = tActiveTab || "temelbilgiler";
		}

		error.citySubdivisionName = validateField(undefined, "1,255", externalCustomerAddress.citySubdivisionName);
		if (!error.citySubdivisionName.valid) {
			errorMessage = errorMessage + " <strong>İlçe " + error.citySubdivisionName.message + "</strong><br/>";
			tActiveTab = tActiveTab || "temelbilgiler";
		}

		error.countryName = validateField(undefined, "1,255", externalCustomerAddress.countryName);
		if (!error.countryName.valid) {
			errorMessage = errorMessage + " <strong>Ülke " + error.countryName.message + "</strong><br/>";
			tActiveTab = tActiveTab || "temelbilgiler";
		}

		error.email = validateField("email", "0,255", externalCustomerAddress.email);
		if (!error.email.valid) {
			errorMessage = errorMessage + " <strong> Alıcı e-Posta " + error.email.message + "</strong><br/>";
			tActiveTab = tActiveTab || "temelbilgiler";
		}
	} else {
		let docExternalCustomer = (data.trdDocExternalCustomer || {});
		error.email = validateField("email", "0,255", docExternalCustomer.email);
		if (!error.email.valid) {
			errorMessage = errorMessage + " <strong>E-Posta " + error.email.message + "</strong><br/>";
			tActiveTab = tActiveTab || "temelbilgiler";
		}

		let length = (isset(docExternalCustomer.vknTckn) ? docExternalCustomer.vknTckn.length : 11);
		error.vknTckn = validateField("identifier", "10,11", docExternalCustomer.vknTckn);
		if (!error.vknTckn.valid) {
			errorMessage = errorMessage + " <strong>Vkn/Tckn " + error.vknTckn.message + "</strong><br/>";
			tActiveTab = tActiveTab || "temelbilgiler";
		}
		if (length === 11) {
			error.givenName = validateField(undefined, "1,45", docExternalCustomer.givenName);
			if (!error.givenName.valid) {
				errorMessage = errorMessage + " <strong>Adı " + error.givenName.message + "</strong><br/>";
				tActiveTab = tActiveTab || "temelbilgiler";
			}
			error.familyName = validateField(undefined, "1,45", docExternalCustomer.familyName);
			if (!error.familyName.valid) {
				errorMessage = errorMessage + " <strong>Soyadı " + error.familyName.message + "</strong><br/>";
				tActiveTab = tActiveTab || "temelbilgiler";
			}
		} else {
			error.formattedName = validateField(undefined, "1,100", docExternalCustomer.formattedName);
			if (!error.formattedName.valid) {
				errorMessage = errorMessage + " <strong>Ünvan " + error.formattedName.message + "</strong><br/>";
				tActiveTab = tActiveTab || "temelbilgiler";
			}

			if ("2222222222" !== docExternalCustomer.vknTckn	) {
				error.taxOffice = validateField(undefined, "1,255", externalCustomer.taxOffice);
				if (!error.taxOffice.valid) {
					errorMessage = errorMessage + " <strong>Vergi dairesi " + error.taxOffice.message + "</strong><br/>";
					tActiveTab = tActiveTab || "temelbilgiler";
				}
			}
		}

		error.cityName = validateField(undefined, "1,255", docExternalCustomer.cityName);
		if (!error.cityName.valid) {
			errorMessage = errorMessage + " <strong>İl " + error.cityName.message + "</strong><br/>";
			tActiveTab = tActiveTab || "temelbilgiler";
		}

		error.citySubdivisionName = validateField(undefined, "1,255", docExternalCustomer.citySubdivisionName);
		if (!error.citySubdivisionName.valid) {
			errorMessage = errorMessage + " <strong>İlçe " + error.citySubdivisionName.message + "</strong><br/>";
			tActiveTab = tActiveTab || "temelbilgiler";
		}

		error.countryName = validateField(undefined, "1,255", docExternalCustomer.countryName);
		if (!error.countryName.valid) {
			errorMessage = errorMessage + " <strong>Ülke " + error.countryName.message + "</strong><br/>";
			tActiveTab = tActiveTab || "temelbilgiler";
		}
	}

	let iadeTables = data.iadeTables
	let isIade= data.documentTypeCode === "IADE"
	if(isIade){
		for(let i = 0; i < iadeTables.length; i++){
			let iadeTable = iadeTables[i];
			error['faturaNo_' + i] = validateField("faturaNo", "1,16", iadeTable.faturaNo);
			if (!error['faturaNo_' + i].valid) {
				errorMessage = errorMessage + " <strong>" + (i + 1) + ". satırdaki Fatura numarası " + error['faturaNo_' + i].message + "</strong><br/>";
				tActiveTab = tActiveTab || "digerbilgiler";
				tInnerActiveTab = "IadeBilgileri";
			}

			error['duzenlenmeTarihi_' + i] = validateField("date", "1,255", iadeTable.duzenlenmeTarihi);
			if (!error['duzenlenmeTarihi_' + i].valid) {
				errorMessage = errorMessage + " <strong>" + (i + 1) + ". Düzenlenme Tarihi " + error['duzenlenmeTarihi_' + i].message + "</strong><br/>";
				tActiveTab = tActiveTab || "digerbilgiler";
				tInnerActiveTab = "IadeBilgileri";
			}
		}
	}

	let trdDocBelgeLines = data.trdDocBelgeLines;
	let has9015 = false;
	let checkBelgeType = true;
	for (let i = 0; i < trdDocBelgeLines.length; i++) {
		let trdDocBelgeLine = trdDocBelgeLines[i];
		error['itemName_' + i] = validateField(undefined, "1,255", trdDocBelgeLine.itemName);
		if (!error['itemName_' + i].valid) {
			errorMessage = errorMessage + " <strong>" + (i + 1) + ". satırdaki Ürün/Hizmet " + error['itemName_' + i].message + "</strong><br/>";
		}

		let charges = trdDocBelgeLine.trdDocBelgeLineCharges;
		for (let j = 0; j < charges.length; j++) {
			if (charges[j].taxCode.code === "9015") {
				if ((data.documentTypeCode !== "TEVKIFAT" && data.documentTypeCode !== "SGK" && data.documentTypeCode !== "IADE")) {
					errorMessage = errorMessage + +(i + 1) + " . <strong>KDV Tevkifatı ekli iken fatura türü TEVKİFAT, SGK ya da İADE olmalıdır.<br/></strong>";
				} else {
					has9015 = true;
				}
			}

			let gocCheck = false;
			for (let count = 0; count < data.trdDocBelgeNotes.length; count++) {
				if (data.trdDocBelgeNotes[count].note === "FATURATIPI:SGK") {
					gocCheck = true;
				}
			}
			if (charges[j].taxCode.code === "0015") {
				if (((new Decimal(charges[j].percentage)).eq(new Decimal(0)) || (new Decimal(charges[j].amount)).equals(new Decimal(0)))) {
					if (data.profileId !== "IHRACAT" &&
						!charges[j].exemptionReasonCode &&
						data.documentTypeCode !== "SGK" &&
						data.documentTypeCode !== "KONAKLAMAVERGISI" &&
						!isGocIdaresi && !gocCheck) {
						errorMessage = errorMessage + (i + 1) + " .<strong> Satır KDV Değeri Sıfır iken KDV istisna sebebi boş bırakılamaz.<br/></strong>";
					}
					if (data.documentTypeCode !== "IADE" &&
						data.documentTypeCode !== "ISTISNA" &&
						data.documentTypeCode !== "TEVKIFAT" &&
						data.documentTypeCode !== "IHRACKAYITLI" &&
						data.documentTypeCode !== "SGK" &&
						data.documentTypeCode !== "OZELMATRAH" &&
						!isGocIdaresi &&
						!(charges[j].exemptionReasonCode === 351 ||
							charges[j].exemptionReasonCode === "351")) {
						checkBelgeType = false;
					}
					for (let count = 0; count < data.trdDocBelgeNotes.length; count++) {
						if (data.trdDocBelgeNotes[count].note === "FATURATIPI:SGK") {
							checkBelgeType = true;
						}
					}
				}
			}
		}
	}

	if (!checkBelgeType) {
		errorMessage = errorMessage + " <strong>KDV Değeri Sıfır olan satır içeren faturaların senaryo türü IADE, ISTISNA,IHRACKAYITLI yada OZELMATRAH olmalıdır.</strong>";
	}

	if (data.documentTypeCode === "TEVKIFAT") {
		if (!has9015)
			errorMessage = errorMessage + " <strong>Fatura türü TEVKİFAT iken en az bir satıra 9015-KDV TEVKİFAT vergisi eklenmelidir.</strong>";
	}

	if (isKamu) {
		error['paymentMeansCode'] = validateField(undefined, "1,255", data.paymentMeansCode);
		if (!error['paymentMeansCode'].valid) {
			errorMessage = errorMessage + " <strong>Kamuya kesilen faturalarda Ödeme Şekli " + error.paymentMeansCode.message + "</strong><br/>";
			tActiveTab = tActiveTab || "digerbilgiler";
			tInnerActiveTab = "OdemeBilgileri";
		}
		error['paymentChannelCode'] = validateField(undefined, "0,255", data.paymentChannelCode);
		if (!error['paymentChannelCode'].valid) {
			errorMessage = errorMessage + " <strong>Kamuya kesilen faturalarda  Ödeme Kanalı " + error.paymentChannelCode.message + "</strong><br/>";
			tActiveTab = tActiveTab || "digerbilgiler";
			tInnerActiveTab = "OdemeBilgileri";
		}
		error['paymentFinancialAccountId'] = validateField('iban', "1,255", data.paymentFinancialAccountId);
		if (!error['paymentFinancialAccountId'].valid) {
			errorMessage = errorMessage + " <strong>Kamuya kesilen faturalarda  Hesap Numarası " + error.paymentFinancialAccountId.message + "</strong><br/>";
			tActiveTab = tActiveTab || "digerbilgiler";
			tInnerActiveTab = "OdemeBilgileri";
		}
		error['paymentFormattedName'] = validateField(undefined, "1,350", data.paymentFormattedName);
		if (!error['paymentFormattedName'].valid) {
			errorMessage = errorMessage + " <strong>Kamuya kesilen faturalarda ödeme Yapacak Alıcı Ünvanı " + error.paymentFormattedName.message + "</strong><br/>";
			tActiveTab = tActiveTab || "digerbilgiler";
			tInnerActiveTab = "OdemeBilgileri";
		}
		error['paymentVkn'] = validateField(undefined, "1,10", data.paymentVkn);
		if (!error['paymentVkn'].valid) {
			errorMessage = errorMessage + " <strong>Kamuya kesilen faturalarda ödeme yapacak Alıcı VKN " + error.paymentVkn.message + "</strong><br/>";
			tActiveTab = tActiveTab || "digerbilgiler";
			tInnerActiveTab = "OdemeBilgileri";
		}
		error['paymentCity'] = validateField(undefined, "1,255", data.paymentCity);
		if (!error['paymentCity'].valid) {
			errorMessage = errorMessage + " <strong>Kamuya kesilen faturalarda ödeme yapacak Alıcı İli " + error.paymentCity.message + "</strong><br/>";
			tActiveTab = tActiveTab || "digerbilgiler";
			tInnerActiveTab = "OdemeBilgileri";
		}
		error['paymentCountry'] = validateField(undefined, "1,255", data.paymentCountry);
		if (!error['paymentCountry'].valid) {
			errorMessage = errorMessage + " <strong>Kamuya kesilen faturalarda ödeme yapacak Alıcı Ülkesi " + error.paymentCountry.message + "</strong><br/>";
			tActiveTab = tActiveTab || "digerbilgiler";
			tInnerActiveTab = "OdemeBilgileri";
		}
	}

	let valid = isValidObject(error);
	return {
		error: error,
		valid: valid && !isset(errorMessage),
		errorMessage: errorMessage,
		activeTab: (tActiveTab || activeTab),
		innerActiveTab: (tInnerActiveTab || innerActiveTab)
	};
}

export function isValidVoucher(data, direction) {
	let error = {};
	let errorMessage = "";
	error.allowanceTotalAmount = validateField("decimal", undefined, data.allowanceTotalAmount);
	error.lineExtensionAmount = validateField("decimal", undefined, data.lineExtensionAmount);
	error.payableAmount = validateField("decimal", undefined, data.payableAmount);
	error.taxExclusiveAmount = validateField("decimal", undefined, data.taxExclusiveAmount);
	error.taxInclusiveAmount = validateField("decimal", undefined, data.taxInclusiveAmount);

	let externalCustomer = data.externalCustomer;
	let externalCustomerAddress = data.externalCustomerAddress;
	let tmpDocConnectorExCustomer = data.tmpDocConnectorExCustomer;

	let vknTckn,cityName,citySubdivisionName,countryName,email;
	let givenName,familyName,formattedName,taxOffice,buyerType;

	if(data.from==='CONNECTOR'){
		vknTckn = tmpDocConnectorExCustomer.vknTckn;
		cityName = tmpDocConnectorExCustomer.cityName;
		citySubdivisionName = tmpDocConnectorExCustomer.citySubdivisionName;
		countryName = tmpDocConnectorExCustomer.countryName;
		email = tmpDocConnectorExCustomer.email;
		givenName = tmpDocConnectorExCustomer.givenName;
		familyName = tmpDocConnectorExCustomer.familyName;
		formattedName = tmpDocConnectorExCustomer.formattedName;
		taxOffice = tmpDocConnectorExCustomer.taxOffice;
		buyerType = tmpDocConnectorExCustomer.buyerType;
	}else{
		vknTckn = externalCustomer.vknTckn
		cityName = externalCustomerAddress.cityName
		citySubdivisionName = externalCustomerAddress.citySubdivisionName
		countryName = externalCustomerAddress.countryName
		email = externalCustomerAddress.email
		givenName = externalCustomer.givenName
		familyName = externalCustomer.familyName
		formattedName = externalCustomer.formattedName
		taxOffice = externalCustomer.taxOffice
		buyerType = externalCustomer.buyerType;
	}

	error.sendingType = validateField(undefined, "1,10", data.sendingType);
	if (!error.sendingType.valid) {
		errorMessage = errorMessage + " <strong>Gönderim Şekli " + error.sendingType.message + "</strong><br/>";
	}
	error.documentUuid = validateField("uuid", undefined, data.documentUuid);
	if (data.documentCurrencyCode !== "TRY") {
		error.paymentExchangeRate = validateField("decimal", undefined, data.paymentExchangeRate);
		if (!error.paymentExchangeRate.valid) {
			errorMessage = errorMessage + " <strong>Kur Değeri " + error.paymentExchangeRate.message + "</strong><br/>";
		}
	}

	if (data.profileId === "EDOVIZBELGE"){
		if (data.documentTypeCode === undefined || data.documentTypeCode === null){
			error.documentTypeCode = validateField(undefined, "1,45", data.documentTypeCode);
			if (!error.documentTypeCode.valid) {
				errorMessage = errorMessage + " <strong>Belge Türü " + error.documentTypeCode.message + "</strong><br/>";
			}
		}

		error['paymentMeansCode'] = validateField(undefined, "1,255", data.paymentInfo.paymentMeansCode);
		if (!error['paymentMeansCode'].valid) {
			errorMessage = errorMessage + " <strong>Ödeme Şekli " + error.paymentMeansCode.message + "</strong><br/>";
		}
		if (!!data.exchangeAdditionalDocuments) {
			if (!!data.exchangeAdditionalDocuments.gumrukBeyanTarihi) {
				error.gumrukBeyanTarihi = validateField("datetime", undefined, moment(data.exchangeAdditionalDocuments.gumrukBeyanTarihi).format("DD-MM-YYYY HH:mm:ss"));
				if (!error.gumrukBeyanTarihi.valid) {
					errorMessage = errorMessage + "<strong>" + "Gümrük beyanname" + error.gumrukBeyanTarihi.message + "</strong><br/>";
				}
			}

			if (!!data.exchangeAdditionalDocuments.gmTeyitYazisiTarihi) {
				error.gmTeyitYazisiTarihi = validateField("datetime", undefined, moment(data.exchangeAdditionalDocuments.gmTeyitYazisiTarihi).format("DD-MM-YYYY HH:mm:ss"));
				if (!error.gmTeyitYazisiTarihi.valid) {
					errorMessage = errorMessage + "<strong>" + "Gümrük müdürlüğü teyit yazısı " + error.gmTeyitYazisiTarihi.message + "</strong><br/>";
				}
			}

			if (!!data.exchangeAdditionalDocuments.dovizBeyanTarihi) {
				error.dovizBeyanTarihi = validateField("datetime", undefined, moment(data.exchangeAdditionalDocuments.dovizBeyanTarihi).format("DD-MM-YYYY HH:mm:ss"));
				if (!error.dovizBeyanTarihi.valid) {
					errorMessage = errorMessage + "<strong>" + "Döviz beyan tutanağı" + error.dovizBeyanTarihi.message + "</strong><br/>";
				}
			}
		}
	}


	if(!data.retailCustomer && !data.hasForeignCustomer){
		let length = (vknTckn ? vknTckn.length : 11);
		if (length === 11) {
			error.givenName = validateField(undefined, "1,45", givenName);
			if (!error.givenName.valid) {
				errorMessage = errorMessage + " <strong>Adı " + error.givenName.message + "</strong><br/>";
			}
			error.familyName = validateField(undefined, "1,45", familyName);
			if (!error.familyName.valid) {
				errorMessage = errorMessage + " <strong>Soyadı " + error.familyName.message + "</strong><br/>";
			}
		} else {
			if (data.documentTypeCode !== "MUSTAHSILMAKBUZ") {
				error.formattedName = validateField(undefined, "1,255", formattedName);
				if (!error.formattedName.valid) {
					errorMessage = errorMessage + " <strong>Ünvan " + error.formattedName.message + "</strong><br/>";
				}
			} else {
				errorMessage = errorMessage + " <strong>Müstahsil Makbuzlarında Alıcı Şahıs olmalıdır.</strong><br/>";
			}
		}

		error.taxOffice = validateField(undefined, "0,255", taxOffice);
		if (!error.taxOffice.valid) {
			errorMessage = errorMessage + " <strong>Vergi dairesi " + error.taxOffice.message + "</strong><br/>";
		}

		error.cityName = validateField(undefined, "1,255", cityName);
		if (!error.cityName.valid) {
			errorMessage = errorMessage + " <strong>İl " + error.cityName.message + "</strong><br/>";
		}

		error.citySubdivisionName = validateField(undefined, "1,255", citySubdivisionName);
		if (!error.citySubdivisionName.valid) {
			errorMessage = errorMessage + " <strong>İlçe " + error.citySubdivisionName.message + "</strong><br/>";
		}

		error.countryName = validateField(undefined, "1,255", countryName);
		if (!error.countryName.valid) {
			errorMessage = errorMessage + " <strong>Ülke " + error.countryName.message + "</strong><br/>";
		}

		error.email = validateField("email", "0,255", email);
		if (!error.email.valid) {
			errorMessage = errorMessage + " <strong>" + error.email.message + "</strong><br/>";
		}
	}else if(!data.hasForeignCustomer){
		//retailCustomer ise buraya girecek
		let docExternalCustomer = (data.trdDocExternalCustomer || {});
		error.email = validateField("email", "0,255", docExternalCustomer.email);
		if (!error.email.valid) {
			errorMessage = errorMessage + " <strong>E-Posta " + error.email.message + "</strong><br/>";
		}

		let length = (isset(docExternalCustomer.vknTckn) ? docExternalCustomer.vknTckn.length : 11);
		error.vknTckn = validateField("identifier","10,11" ,docExternalCustomer.vknTckn);
		if (!error.vknTckn.valid) {
			errorMessage = errorMessage + " <strong>Vkn/Tckn " + error.vknTckn.message + "</strong><br/>";
		}
		if (length === 11) {
			error.givenName = validateField(undefined, "1,45", docExternalCustomer.givenName);
			if (!error.givenName.valid) {
				errorMessage = errorMessage + " <strong>Adı " + error.givenName.message + "</strong><br/>";
			}
			error.familyName = validateField(undefined, "1,45", docExternalCustomer.familyName);
			if (!error.familyName.valid) {
				errorMessage = errorMessage + " <strong>Soyadı " + error.familyName.message + "</strong><br/>";
			}
		}else {
			error.formattedName = validateField(undefined, "2,350", docExternalCustomer.formattedName);
			if (!error.formattedName.valid) {
				errorMessage = errorMessage + " <strong>Ünvan " + error.formattedName.message + "</strong><br/>";
			}
		}
		error.cityName = validateField(undefined, "1,255", docExternalCustomer.cityName);
		if (!error.cityName.valid) {
			errorMessage = errorMessage + " <strong>İl " + error.cityName.message + "</strong><br/>";
		}

		error.citySubdivisionName = validateField(undefined, "1,255", docExternalCustomer.citySubdivisionName);
		if (!error.citySubdivisionName.valid) {
			errorMessage = errorMessage + " <strong>İlçe " + error.citySubdivisionName.message + "</strong><br/>";
		}

		error.countryName = validateField(undefined, "1,255", docExternalCustomer.countryName);
		if (!error.countryName.valid) {
			errorMessage = errorMessage + " <strong>Ülke " + error.countryName.message + "</strong><br/>";
		}
	}else {
		if (buyerType === "OZEL") {
			error.givenName = validateField(undefined, "1,45", givenName);
			if (!error.givenName.valid) {
				errorMessage = errorMessage + " <strong>Adı " + error.givenName.message + "</strong><br/>";
			}
			error.familyName = validateField(undefined, "1,45", familyName);
			if (!error.familyName.valid) {
				errorMessage = errorMessage + " <strong>Soyadı " + error.familyName.message + "</strong><br/>";
			}
		} else {
			error.formattedName = validateField(undefined, "1,255", formattedName);
			if (!error.formattedName.valid) {
				errorMessage = errorMessage + " <strong>Resmi Ünvan " + error.formattedName.message + "</strong><br/>";
			}
		}

		error.buyerType = validateField(undefined, "1,45", buyerType);
		if (!error.buyerType.valid) {
			errorMessage = errorMessage + " <strong>Alıcı Türü " + error.buyerType.message + "</strong><br/>";
		}

		error.cityName = validateField(undefined, "1,255", cityName);
		if (!error.cityName.valid) {
			errorMessage = errorMessage + " <strong>İl " + error.cityName.message + "</strong><br/>";
		}

		error.citySubdivisionName = validateField(undefined, "1,255", citySubdivisionName);
		if (!error.citySubdivisionName.valid) {
			errorMessage = errorMessage + " <strong>İlçe " + error.citySubdivisionName.message + "</strong><br/>";
		}

		error.countryName = validateField(undefined, "1,255", countryName);
		if (!error.countryName.valid) {
			errorMessage = errorMessage + " <strong>Ülke " + error.countryName.message + "</strong><br/>";
		}
	}

	if (direction === "Tmp") {
		error.xsltPath = validateField(undefined, "1,255", data.xsltPath);
		if (!error.xsltPath.valid) {
			errorMessage = errorMessage + " <strong>XSLT Dosyası " + error.xsltPath.message + "</strong><br/>";
		}
	}

	let trdDocVoucherNotes = data.trdDocVoucherNotes;
	for (let i = 0; i < trdDocVoucherNotes.length; i++) {
		error['trdDocVoucherNote_' + i] = validateField(undefined, "0,5000", trdDocVoucherNotes[i].note);
		if (!error['trdDocVoucherNote_' + i].valid) {
			errorMessage = errorMessage + " <strong>Açıklama " + error['trdDocVoucherNote_' + i].message + "</strong><br/>";
		}
	}

	let trdDocVoucherLines = data.trdDocVoucherLines;
	for (let i = 0; i < trdDocVoucherLines.length; i++) {
		let trdDocVoucherLine = trdDocVoucherLines[i];
		error['itemName_' + i] = validateField(undefined, "1,1000", trdDocVoucherLine.itemName);
		if (!error['itemName_' + i].valid) {
			errorMessage = errorMessage + " <strong>" + (i + 1) + ". satırdaki Ürün/Hizmet " + error['itemName_' + i].message + "</strong><br/>";
		}
		if (new Decimal(trdDocVoucherLine.quantity).eq(0.00)) {
			errorMessage = errorMessage + (i + 1) + " .<strong> satırdaki miktar 0 olamaz.<br/></strong>";
		}
		if (data.documentTypeCode === "MUSTAHSILMAKBUZ" &&(trdDocVoucherLine.kunyeNo && trdDocVoucherLine.kunyeNo.length !== 0)) {
			error['kunyeNo_' + i] = validateField("kunyeNo", "0,19", trdDocVoucherLine.kunyeNo);
			if (!error['kunyeNo_' + i].valid) {
				errorMessage = errorMessage + " <strong>" + (i + 1) + ". satırdaki " + error['kunyeNo_' + i].message + "</strong><br/>";
			}
		}

		let charges = trdDocVoucherLine.trdDocVoucherLineCharges;
		for (let j = 0; j < charges.length; j++) {
			if (charges[j].taxCode.code === "0015" && data.documentTypeCode === "SERBESTMESLEKMAKBUZ") {
				let percantage = new Decimal(charges[j].percentage);
				if (!(percantage.eq(new Decimal(0)) ||
					percantage.eq(new Decimal(1)) ||
					percantage.eq(new Decimal(8)) ||
					percantage.eq(new Decimal(10)) ||
					percantage.eq(new Decimal(18)) ||
					percantage.eq(new Decimal(20)))) {
					errorMessage = errorMessage + (i + 1) + " .<strong> Satır KDV Değeri 0,1,8,10,18,20 değerlerinden biri olmalıdır.<br/></strong>";
				}
			}
			if (charges[j].taxCode.code === "SGK_PRIM" && data.documentTypeCode === "MUSTAHSILMAKBUZ"){
				let percantage = new Decimal(charges[j].percentage);
				if (percantage.eq(new Decimal(0))){
					errorMessage = errorMessage + (i + 1) + " .<strong> SGK PRİM KESİNTİSİ 0 Olamaz.<br/></strong>";
				}
			}
			if (charges[j].taxCode.code === "9040" && data.documentTypeCode === "MUSTAHSILMAKBUZ"){
				let percantage = new Decimal(charges[j].percentage);
				if (percantage.eq(new Decimal(0))){
					errorMessage = errorMessage + (i + 1) + " .<strong> MERA FONU 0 Olamaz.<br/></strong>";
				}
			}
			if (charges[j].taxCode.code === "8001_8001" && data.documentTypeCode === "MUSTAHSILMAKBUZ"){
				let percantage = new Decimal(charges[j].percentage);
				if (percantage.eq(new Decimal(0))){
					errorMessage = errorMessage + (i + 1) + " .<strong> BORSA TESCİL ÜCRETİ 0 Olamaz.<br/></strong>";
				}
			}
		}
	}
	let valid = isValidObject(error);
	return {error: error, valid: valid && !isset(errorMessage), errorMessage: errorMessage};
}

export function isset(value) {
	return (typeof value !== "undefined" && value !== null && value !== "");
}

export function isValidSigorta(data) {
	let error = {};
	let errorMessage = "";
	error.allowanceTotalAmount = validateField("decimal", undefined, data.allowanceTotalAmount);
	error.lineExtensionAmount = validateField("decimal", undefined, data.lineExtensionAmount);
	error.payableAmount = validateField("decimal", undefined, data.payableAmount);
	error.taxExclusiveAmount = validateField("decimal", undefined, data.taxExclusiveAmount);
	error.taxInclusiveAmount = validateField("decimal", undefined, data.taxInclusiveAmount);

	let externalCustomer = data.externalCustomer;
	let externalCustomerAddress = data.externalCustomerAddress;
	let tmpDocConnectorExCustomer = data.tmpDocConnectorExCustomer;

	let vknTckn,cityName,citySubdivisionName,countryName,email;
	let givenName,familyName,formattedName,taxOffice,buyerType;

	if(data.from==='CONNECTOR'){
		vknTckn = tmpDocConnectorExCustomer.vknTckn;
		cityName = tmpDocConnectorExCustomer.cityName;
		citySubdivisionName = tmpDocConnectorExCustomer.citySubdivisionName;
		countryName = tmpDocConnectorExCustomer.countryName;
		email = tmpDocConnectorExCustomer.email;
		givenName = tmpDocConnectorExCustomer.givenName;
		familyName = tmpDocConnectorExCustomer.familyName;
		formattedName = tmpDocConnectorExCustomer.formattedName;
		taxOffice = tmpDocConnectorExCustomer.taxOffice;
		buyerType = tmpDocConnectorExCustomer.buyerType;
	}else{
		vknTckn = externalCustomer.vknTckn
		cityName = externalCustomerAddress.cityName
		citySubdivisionName = externalCustomerAddress.citySubdivisionName
		countryName = externalCustomerAddress.countryName
		email = externalCustomerAddress.email
		givenName = externalCustomer.givenName
		familyName = externalCustomer.familyName
		formattedName = externalCustomer.formattedName
		taxOffice = externalCustomer.taxOffice
		buyerType = externalCustomer.buyerType;
	}

	error.sendingType = validateField(undefined, "1,10", data.sendingType);
	if (!error.sendingType.valid) {
		errorMessage = errorMessage + " <strong>Gönderim Şekli " + error.sendingType.message + "</strong><br/>";
	}
	error.documentUuid = validateField("uuid", undefined, data.documentUuid);
	if (data.documentCurrencyCode !== "TRY") {
		error.paymentExchangeRate = validateField("decimal", undefined, data.paymentExchangeRate);
		if (!error.paymentExchangeRate.valid) {
			errorMessage = errorMessage + " <strong>Kur Değeri " + error.paymentExchangeRate.message + "</strong><br/>";
		}
	}

	error.periodStartDateTime = validateField("datetime", "1,20", moment(data.periodStartDateTime).format("DD-MM-YYYY HH:mm:ss"));
	if (!error.periodStartDateTime.valid) {
		errorMessage = errorMessage + " <strong> Dönem Başlangıç Tarihi " + error.periodStartDateTime.message + " </strong> <br/> ";

	}
	error.periodEndDateTime = validateField("datetime", "1,20", moment(data.periodEndDateTime).format("DD-MM-YYYY HH:mm:ss"));
	if (!error.periodEndDateTime.valid) {
		errorMessage = errorMessage + " <strong> Dönem Bitiş Tarihi " + error.periodEndDateTime.message + " </strong> <br/> ";

	}

	if(!data.retailCustomer && !data.hasForeignCustomer){
		let length = (vknTckn ? vknTckn.length : 11);
		if (length === 11) {
			error.givenName = validateField(undefined, "1,45", givenName);
			if (!error.givenName.valid) {
				errorMessage = errorMessage + " <strong>Adı " + error.givenName.message + "</strong><br/>";
			}
			error.familyName = validateField(undefined, "1,45", familyName);
			if (!error.familyName.valid) {
				errorMessage = errorMessage + " <strong>Soyadı " + error.familyName.message + "</strong><br/>";
			}
		} else {
			error.formattedName = validateField(undefined, "1,255", formattedName);
			if (!error.formattedName.valid) {
				errorMessage = errorMessage + " <strong>Ünvan " + error.formattedName.message + "</strong><br/>";
			}

		}

		error.taxOffice = validateField(undefined, "0,255", taxOffice);
		if (!error.taxOffice.valid) {
			errorMessage = errorMessage + " <strong>Vergi dairesi " + error.taxOffice.message + "</strong><br/>";
		}

		error.cityName = validateField(undefined, "1,255", cityName);
		if (!error.cityName.valid) {
			errorMessage = errorMessage + " <strong>İl " + error.cityName.message + "</strong><br/>";
		}

		error.citySubdivisionName = validateField(undefined, "1,255", citySubdivisionName);
		if (!error.citySubdivisionName.valid) {
			errorMessage = errorMessage + " <strong>İlçe " + error.citySubdivisionName.message + "</strong><br/>";
		}

		error.countryName = validateField(undefined, "1,255", countryName);
		if (!error.countryName.valid) {
			errorMessage = errorMessage + " <strong>Ülke " + error.countryName.message + "</strong><br/>";
		}

		error.email = validateField("email", "0,255", email);
		if (!error.email.valid) {
			errorMessage = errorMessage + " <strong>" + error.email.message + "</strong><br/>";
		}
	}else if(!data.hasForeignCustomer){
		//retailCustomer ise buraya girecek
		let docExternalCustomer = (data.trdDocExternalCustomer || {});
		error.email = validateField("email", "0,255", docExternalCustomer.email);
		if (!error.email.valid) {
			errorMessage = errorMessage + " <strong>E-Posta " + error.email.message + "</strong><br/>";
		}

		let length = (isset(docExternalCustomer.vknTckn) ? docExternalCustomer.vknTckn.length : 11);
		error.vknTckn = validateField("identifier","10,11" ,docExternalCustomer.vknTckn);
		if (!error.vknTckn.valid) {
			errorMessage = errorMessage + " <strong>Vkn/Tckn " + error.vknTckn.message + "</strong><br/>";
		}
		if (length === 11) {
			error.givenName = validateField(undefined, "1,45", docExternalCustomer.givenName);
			if (!error.givenName.valid) {
				errorMessage = errorMessage + " <strong>Adı " + error.givenName.message + "</strong><br/>";
			}
			error.familyName = validateField(undefined, "1,45", docExternalCustomer.familyName);
			if (!error.familyName.valid) {
				errorMessage = errorMessage + " <strong>Soyadı " + error.familyName.message + "</strong><br/>";
			}
		}else {
			error.formattedName = validateField(undefined, "2,350", docExternalCustomer.formattedName);
			if (!error.formattedName.valid) {
				errorMessage = errorMessage + " <strong>Ünvan " + error.formattedName.message + "</strong><br/>";
			}
		}
		error.cityName = validateField(undefined, "1,255", docExternalCustomer.cityName);
		if (!error.cityName.valid) {
			errorMessage = errorMessage + " <strong>İl " + error.cityName.message + "</strong><br/>";
		}

		error.citySubdivisionName = validateField(undefined, "1,255", docExternalCustomer.citySubdivisionName);
		if (!error.citySubdivisionName.valid) {
			errorMessage = errorMessage + " <strong>İlçe " + error.citySubdivisionName.message + "</strong><br/>";
		}

		error.countryName = validateField(undefined, "1,255", docExternalCustomer.countryName);
		if (!error.countryName.valid) {
			errorMessage = errorMessage + " <strong>Ülke " + error.countryName.message + "</strong><br/>";
		}
	}else {
		if (buyerType === "OZEL") {
			error.givenName = validateField(undefined, "1,45", givenName);
			if (!error.givenName.valid) {
				errorMessage = errorMessage + " <strong>Adı " + error.givenName.message + "</strong><br/>";
			}
			error.familyName = validateField(undefined, "1,45", familyName);
			if (!error.familyName.valid) {
				errorMessage = errorMessage + " <strong>Soyadı " + error.familyName.message + "</strong><br/>";
			}
		} else {
			error.formattedName = validateField(undefined, "1,255", formattedName);
			if (!error.formattedName.valid) {
				errorMessage = errorMessage + " <strong>Resmi Ünvan " + error.formattedName.message + "</strong><br/>";
			}
		}

		error.buyerType = validateField(undefined, "1,45", buyerType);
		if (!error.buyerType.valid) {
			errorMessage = errorMessage + " <strong>Alıcı Türü " + error.buyerType.message + "</strong><br/>";
		}

		error.cityName = validateField(undefined, "1,255", cityName);
		if (!error.cityName.valid) {
			errorMessage = errorMessage + " <strong>İl " + error.cityName.message + "</strong><br/>";
		}

		error.citySubdivisionName = validateField(undefined, "1,255", citySubdivisionName);
		if (!error.citySubdivisionName.valid) {
			errorMessage = errorMessage + " <strong>İlçe " + error.citySubdivisionName.message + "</strong><br/>";
		}

		error.countryName = validateField(undefined, "1,255", countryName);
		if (!error.countryName.valid) {
			errorMessage = errorMessage + " <strong>Ülke " + error.countryName.message + "</strong><br/>";
		}
	}

	error.xsltPath = validateField(undefined, "1,255", data.xsltPath);
	if (!error.xsltPath.valid) {
		errorMessage = errorMessage + " <strong>XSLT Dosyası " + error.xsltPath.message + "</strong><br/>";
	}


	let trdDocSigortaNotes = data.trdDocSigortaNotes;
	for (let i = 0; i < trdDocSigortaNotes.length; i++) {
		error['trdDocSigortaNote_' + i] = validateField(undefined, "0,5000", trdDocSigortaNotes[i].note);
		if (!error['trdDocSigortaNote_' + i].valid) {
			errorMessage = errorMessage + " <strong>Açıklama " + error['trdDocSigortaNote_' + i].message + "</strong><br/>";
		}
	}

	let trdDocSigortaLines = data.trdDocSigortaLines;
	for (let i = 0; i < trdDocSigortaLines.length; i++) {
		let trdDocSigortaLine = trdDocSigortaLines[i];
		error['itemName_' + i] = validateField(undefined, "1,1000", trdDocSigortaLine.itemName);
		if (!error['itemName_' + i].valid) {
			errorMessage = errorMessage + " <strong>" + (i + 1) + ". satırdaki Açıklama " + error['itemName_' + i].message + "</strong><br/>";
		}
		/*if (new Decimal(trdDocSigortaLine.cancelCommissionPrice).eq(0.00)) {
			errorMessage = errorMessage + (i + 1) + " .<strong> satırdaki İptal Komisyonu 0 olamaz.<br/></strong>";
		}*/
	}
	let valid = isValidObject(error);
	return {error: error, valid: valid && !isset(errorMessage), errorMessage: errorMessage};
}

export function isValidObject(error) {
	let valid = true;
	for (let key in error) {
		let tError = error[key];
		if (tError && !tError.valid) {
			valid = false;
			break;
		}
	}
	return valid;
}

export function isValidHiddenVknTcknList(hiddenVknTcknList) {
	let error = {};
	let errorMessage = "";
	for (let i = 0; i < hiddenVknTcknList.length; i++) {
		let hiddenVknTckn = hiddenVknTcknList[i];
		error['userId_' + i] = validateField(undefined, "1,1000", hiddenVknTckn.userId);
		if (!error['userId_' + i].valid) {
			errorMessage = errorMessage + " <strong>" + (i + 1) + ". satırdaki Kullanıcı " + error['userId_' + i].message + "</strong><br/>";
		}
		error['vknTckn_' + i] = validateField(undefined, "10,11", hiddenVknTckn.vknTckn);
		if (!error['vknTckn_' + i].valid) {
			errorMessage = errorMessage + " <strong>" + (i + 1) + ". satırdaki VKN/TCKN " + error['vknTckn_' + i].message + "</strong><br/>";
		}
		error['invoiceType_' + i] = validateField(undefined, "1,1000", hiddenVknTckn.invoiceType);
		if (!error['invoiceType_' + i].valid) {
			errorMessage = errorMessage + " <strong>" + (i + 1) + ". satırdaki Listeleme Türü" + error['invoiceType_' + i].message + "</strong><br/>";
		}
	}

	let valid = isValidObject(error);
	return {error: error, valid: valid && !isset(errorMessage), errorMessage: errorMessage};
}

export function isValidVoucherLine(voucherLine){

	let error = {};
	let errorMessage = "";
	error.itemName = validateField(undefined, "1,1000", voucherLine.itemName);
	if (!error.itemName.valid) {
		errorMessage = errorMessage + " <strong>Ürün / Hizmet Adı alanı boş bırakılamaz</strong><br/>";
	}
	error.unitPrice = validateField("decimal", "1,45", voucherLine.unitPrice);
	if (!error.unitPrice.valid) {
		errorMessage = errorMessage + " <strong>Birim Fiyat alanı boş bırakılamaz</strong><br/>";
	}
	if((voucherLine.kunyeNo && voucherLine.kunyeNo.length !== 0)){
		error.kunyeNo = validateField("kunyeNo", undefined, voucherLine.kunyeNo);
		if (!error.kunyeNo.valid ) {
			errorMessage = errorMessage + " <strong> Künye Numarası 19 hane olmalıdır </strong><br/>";
		}
	}
	if((voucherLine.malSahibiVkntckn && voucherLine.malSahibiVkntckn.length !== 0)){
		error.malSahibiVkntckn = validateField("identifier", "1,11", voucherLine.malSahibiVkntckn);
		if (!error.malSahibiVkntckn.valid ) {
			errorMessage = errorMessage + " <strong> Mal Sahibi VKN/TCKN Hatalıdır </strong><br/>";
		}
	}
	let valid = isValidObject(error);
	return {error: error, valid: valid, errorMessage: errorMessage};
}

export function isValidAnnouncement(announcement) {
	let error = {};
	let errorMessage = "";
	if(!announcement.showAll &&
		!announcement.includeDistributors &&
		!announcement.excludeDistributors &&
		!announcement.includeCitiesList ) {
		errorMessage = errorMessage + " <strong> 'Tüm müşterilerde gösterilsin' seçili değilken (bayi) veya ( il ) seçimi yapmalısınız</strong><br/>";
	}

	error['name'] = validateField(undefined, "1,255", announcement.name);
	if (!error['name'].valid) {
		errorMessage = errorMessage + " <strong> Duyuru Adı " + error['name'].message + "</strong><br/>";
	}

	error['type'] = validateField(undefined, "1,255", announcement.type);
	if (!error['type'].valid) {
		errorMessage = errorMessage + " <strong> Duyuru Türü " + error['type'].message + "</strong><br/>";
	}

	error['startTime'] = validateField('datetimeY', "1,1000", announcement.startTime);
	if (!error['startTime'].valid) {
		errorMessage = errorMessage + " <strong> Başlangıç Tarihi " + error['startTime'].message + "</strong><br/>";
	}

	error['finishTime'] = validateField('datetimeY', "1,1000", announcement.finishTime);
	if (!error['finishTime'].valid) {
		errorMessage = errorMessage + " <strong> Bitiş Tarihi " + error['finishTime'].message + "</strong><br/>";
	}

	error['showCount'] = validateField(undefined, "1,1000", announcement.showCount);
	if (!error['showCount'].valid) {
		errorMessage = errorMessage + " <strong> Tekrar Sayısı: " + error['showCount'].message + "</strong><br/>";
	}

	error['content'] = validateField(undefined, "1,1000", announcement.content);
	if (!error['content'].valid) {
		errorMessage = errorMessage + " <strong> Duyuru İçeriği: " + error['content'].message + "</strong><br/>";
	}

	let valid = isValidObject(error);
	return {
		error: error,
		valid: valid && !isset(errorMessage),
		errorMessage: errorMessage,
	};
}

export function isValidSurvey(survey) {
	let error = {};
	let errorMessage = "";
	if(!survey.showAll &&
		!survey.includeDistributors &&
		!survey.excludeDistributors &&
		!survey.surveyOptions ) {
		errorMessage = errorMessage + " <strong> 'Tüm müşterilerde gösterilsin' seçili değilken (bayi) veya ( il ) seçimi yapmalısınız</strong><br/>";
	}

	if (!survey.surveyOptions || survey.surveyOptions.length < 2) {
		errorMessage = errorMessage + " <strong> En az 2 seçenek eklemelisiniz</strong><br/>";
	}

	error['name'] = validateField(undefined, "1,255", survey.title);
	if (!error['name'].valid) {
		errorMessage = errorMessage + " <strong> Anket Başlığı " + error['title'].message + "</strong><br/>";
	}

	error['startDate'] = validateField('datetimeY', "1,1000", survey.startDate);
	if (!error['startDate'].valid) {
		errorMessage = errorMessage + " <strong> Başlangıç Tarihi " + error['startDate'].message + "</strong><br/>";
	}

	error['endDate'] = validateField('datetimeY', "1,1000", survey.endDate);
	if (!error['endDate'].valid) {
		errorMessage = errorMessage + " <strong> Bitiş Tarihi " + error['endDate'].message + "</strong><br/>";
	}

	error['content'] = validateField(undefined, "1,1000", survey.content);
	if (!error['content'].valid) {
		errorMessage = errorMessage + " <strong> Duyuru İçeriği: " + error['content'].message + "</strong><br/>";
	}

	let valid = isValidObject(error);
	return {
		error: error,
		valid: valid && !isset(errorMessage),
		errorMessage: errorMessage,
	};
}

export function isValidChemistInformation(chemistInformation, cityList, taxOfficeList) {
	let error = {};
	let errorMessage = "";

	if (!chemistInformation.naceCodes || chemistInformation.naceCodes.length === 0) {
		errorMessage += " <strong> En az 1 adet nace kodu seçilmelidir. </strong><br/>";
	}

	if (chemistInformation.vknTckn.length === 10) {
		error.formattedName = validateField(undefined, "1,350", chemistInformation.formattedName)
		if (!error.formattedName.valid) {
			errorMessage += " <strong> Eczane Adı " + error.formattedName.message + "</strong><br/>";
		}
	} else if (chemistInformation.vknTckn.length === 11) {
		error.givenName = validateField("undefined", "1,45", chemistInformation.givenName)
		if (!error.givenName.valid) {
			errorMessage += " <strong> Ad " + error.givenName.message + "</strong><br/>";
		}

		error.familyName = validateField("undefined", "1,45", chemistInformation.familyName)
		if (!error.familyName.valid) {
			errorMessage += " <strong> Ad " + error.familyName.message + "</strong><br/>";
		}
	}

	error.sorumluCepTel = validateField("phoneRequired", "1,13", chemistInformation.sorumluCepTel)
	if (!error.sorumluCepTel.valid) {
		errorMessage += " <strong> Sorumlu Cep Telefonu " + error.sorumluCepTel.message + "</strong><br/>";
	}

	error.sorumluEPosta = validateField("email", "1,255", chemistInformation.sorumluEPosta)
	if (!error.sorumluEPosta.valid) {
		errorMessage += " <strong> Sorumlu e-Posta " + error.sorumluEPosta.message + "</strong><br/>";
	}

	error.corporateMail = validateField("email", "1,255", chemistInformation.corporateMail)
	if (!error.corporateMail.valid) {
		errorMessage += " <strong> Kurumsal e-Posta " + error.corporateMail.message + "</strong><br/>";
	}

	error.city = validateField("required", "1,45", chemistInformation.city);
	if (!error.city.valid) {
		errorMessage += " <strong> Vergi Dairesinin Bulunduğu İl " + error.city.message + "</strong><br/>";
	} else {
		if (!cityList.filter(c => c.cityName === chemistInformation.city).length > 0) {
			errorMessage += " <strong> Vergi Dairesinin Bulunduğu İl alanı boş olamaz.</strong><br/>";
		}
	}

	error.taxOffice = validateField("required", "1,255", chemistInformation.taxOffice);
	if (!error.taxOffice.valid) {
		errorMessage += " <strong> Vergi Dairesi " + error.taxOffice.message + "</strong><br/>";
	} else {
		if (!taxOfficeList.filter(c => c.vdName === chemistInformation.taxOffice).length > 0) {
			errorMessage += " <strong> Vergi Dairesi alanı boş olamaz.</strong><br/>";
		}
	}

	error.application = validateField("required", "1,45", chemistInformation.application);
	if (!error.application.valid) {
		errorMessage += " <strong> Eczane Otomasyon " + error.application.message + "</strong><br/>";
	}

	error.applicationOther = validateField(undefined, ("DIGER" === chemistInformation.application ? "5,45" : "0,45"), chemistInformation.applicationOther);
	if (!error.applicationOther.valid) {
		errorMessage += " <strong> Eczane Otomasyon(Diğer) " + error.applicationOther.message + "</strong><br/>";
	}

	let bankError = {};
	for (const bank of chemistInformation.bankList) {
		bankError = validateField(undefined, "3,1000", bank.bankName);
		if (!bankError.valid) {
			errorMessage += " <strong> ";
			if (bank.type === CustomerBankType.SGK) {
				errorMessage += "SGK banka bilgisi banka adı " + bankError.message;
			} else if (bank.type === CustomerBankType.KAMU) {
				errorMessage += "KAMU banka bilgisi banka adı " + bankError.message;
			} else if (bank.type === CustomerBankType.OTHER) {
				errorMessage += "DİĞER banka bilgisi banka adı " + bankError.message;
			}
			errorMessage += " </strong><br/>";
		}

		bankError = validateField("iban", "1,45", bank.iban)
		if (!bankError.valid) {
			errorMessage += " <strong> ";
			if (bank.type === CustomerBankType.SGK) {
				errorMessage += "SGK banka bilgisi iban " + bankError.message;
			} else if (bank.type === CustomerBankType.KAMU) {
				errorMessage += "KAMU banka bilgisi iban " + bankError.message;
			} else if (bank.type === CustomerBankType.OTHER) {
				errorMessage += "DİĞER banka bilgisi iban " + bankError.message;
			}
			errorMessage += " </strong><br/>";
		}
	}

	return {
		error: error,
		valid: !isset(errorMessage),
		errorMessage: errorMessage,
	};
}